import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FetchScreeningList,
  updateRoundStatus,
} from "../../services/screeningService";
import { toast } from "react-toastify";
import api from "../../api";
import {
  updatestatus,
  FetchFilterInfo,
  getFilteredList,
  fetchNextRoundData,
  createfeedback,
} from "../../services/pendingService";
import { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { utils } from "react-modern-calendar-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import action2 from "../../assets/images/brands/on-hold.svg";
import action3 from "../../assets/images/brands/Rejected.svg";
import { CSVLink } from "react-csv";
import {
  getAdminFeedbackData,
  getCandidateNotes,
  removeCandidateNotes,
  getRemarks,
} from "helpers/backend_helper";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import cross from "../../assets/images/icon/cross.svg";
import job from "../../assets/images/icon/job-port.svg";
import education from "../../assets/images/icon/education-role.svg";
import star_exp from "../../assets/images/icon/exp_job.svg";
import name_icon from "../../assets/images/icon/name01.svg";
import delete_icon from "../../assets/images/icon/delete.svg";

import screening_icon from "../../assets/images/brands/Selected.svg";
import progress_icon from "../../assets/images/brands/In-progess.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import user_icons1 from "../../assets/images/icon/user-ico7.svg";
import edit_icon from "../../assets/images/icon/edit.svg";

import gmeet from "../../assets/images/icon/g-meet.svg";
import zoom from "../../assets/images/icon/zoom.png";
import teams from "../../assets/images/icon/microsoft-teams.png";
import locationma from "../../assets/images/icon/location-card.svg";

import addnotoes from "../../assets/images/icon/addnotoes.svg";

import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
  getDeviceInfo,
  formatDate,
  checkMeetingPlatform,
  generateMaskedPII,
  getSubdomain,
} from "helpers/utils";
import { updateselected } from "services/scheduledService";
import { AvField, AvForm } from "availity-reactstrap-validation";
import authHeader from "helpers/jwt-token-access/auth-token-header";
import { Spinner } from "reactstrap";
import { getInterviewStatus } from "helpers/common";
import { getUserInfo, getUserToken } from "helpers/authHelper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { decryptDataFromArray } from "helpers/EncDec";
import { MultiSelect } from "react-multi-select-component";
import RatingStars from "./RatingStars";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faEye } from "@fortawesome/free-solid-svg-icons";
import TimeslotBookingAdmin from "./TimeslotBookingAdmin";
import ButtonLoader from "components/Common/ButtonLoader";
import { Trans, useTranslation } from "react-i18next";
import RoundList from "components/RoundList";
import RemotePagination from "components/Common/RemotePagination";
import SearchBar from "components/Common/Searchbar";

function ScreeningTest(props) {
  const getDashboardFilterData = key => {
    let payloadObj = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    if (!key || !payloadObj?.filterValue) {
      return;
    }
    let dashboardFilters = localStorage.getItem("dashboardFilters")
      ? JSON.parse(localStorage.getItem("dashboardFilters"))
      : {};
    return dashboardFilters?.[key] || "";
  };
  const { t } = useTranslation();
  const [isReject, setIsReject] = useState(false);
  const [screeningData, setScreeningData] = useState([]);
  const [roleTypes, setRoleTypes] = useState([]);
  const [selectedRoleOptions, setSelectedRoleOptions] = useState([]);
  const [gender, setGender] = useState("");
  const [sourceType, setSourceType] = useState([]);
  const [source, setSource] = useState("");
  const [onboarding, setOnboarding] = useState("");
  const [states, setStates] = useState([]);
  const [state, setState] = useState("");
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState("");
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [city, setCity] = useState("");
  const [startDate, setStartDate] = useState(
    getDashboardFilterData("startDate")
      ? new Date(getDashboardFilterData("startDate"))
      : ""
  );
  const [endDate, setEndDate] = useState(
    getDashboardFilterData("endDate")
      ? new Date(getDashboardFilterData("endDate"))
      : ""
  );
  const [type, setType] = useState(getDashboardFilterData("type") || "");
  const [query, setQuery] = useState("");
  const userInfo = getUserInfo();
  const userloggedinId = userInfo?.id;

  const canScheduleInterview = checkPermissionStatus(
    "screening-list",
    "schedule"
  );

  const canAssignInterviewer = checkPermissionStatus(
    "screening-list",
    "assign_interviewer"
  );
  const teamsIntegrated = userInfo?.teams_integration || false;

  const [int_start_time, setStartTime] = useState("");
  const [int_end_time, setEndTime] = useState("");
  const [interviewType, setInterviewType] = useState("");
  const [categoryRatings, setCategoryRatings] = useState({
    Behavior: 0,
    Psychometric: 0,
    Technical: 0,
    Numerical: 0,
  });
  const [selectedStartTime, setSelectedStartTime] = useState("");
  const [sDateTimeSlots, setsDateTimeSlots] = useState([]);
  const [eDateTimeSlots, seteDateTimeSlots] = useState([]);
  const [bookedTimeSlots, setbookedTimeSlots] = useState([]);
  const [selectedEndTime, setSelectedEndTime] = useState("");
  const [isTimeslotBtnDisabled, setIsTimeslotBtnDisabled] = useState(true);
  const history = useHistory();
  const categories = [
    { name: "Behavior", totalStars: 5 },
    { name: "Psychometric", totalStars: 5 },
    { name: "Technical", totalStars: 5 },
    { name: "Numerical", totalStars: 5 },
  ];
  const [daytimeSlots, setDaytimeSlots] = useState("");
  const [timeSlotsData, settimeSlotsData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSchedule, setIsLoadingSchedule] = useState(false);
  const [showTimeslotBooking, setShowTimeslotBooking] = useState(false);
  const [allNotes, setAllNotes] = useState([]);
  const subdomain = localStorage.getItem("subdomain") || "";
  const [actionType, setActionType] = useState("reject");
  const [offerLetterError, setOfferLetterError] = useState("");
  const STATUS_MAP = {
    reject: { code: 5, label: "Rejected" },
    shortlist: { code: 2, label: "Shortlisted" },
    selectcandidate: { code: 3, label: "Selected" },
    hold: { code: 4, label: "Onhold" },
  };
  const [remarks, setRemarks] = useState([]);
  const [selectedRemark, setSelectedRemark] = useState(null);
  // Function to update the state in the parent component
  const handleChildValueChange = value => {
    // Parse the JSON string into an object
    const jsonObject = JSON.parse(value);
    setDaytimeSlots(jsonObject);
  };

  useEffect(() => {
    if (isReject && actionType === "reject") {
      fetchRemarks();
    } else {
      // reset when switching action
      setRemarks([]);
      setSelectedRemark(null);
      setComment("");
      setCommentError("");
    }
  }, [isReject, actionType]);

  const handleRemarkChange = e => {
    const remarkId = e.target.value;
    const remark = remarks.find(r => r.id == remarkId);

    setSelectedRemark(remark);

    // Optional: auto-fill comment
    // setComment(remark?.remark_label || "");
  };

  const fetchRemarks = async () => {
    try {
      const res = await getRemarks("reject");
      console.log(res.data, "Remarks");
      setRemarks(res.data); // or res.data.data (check API)
    } catch (err) {
      console.error(err);
    }
  };
  // Day to integer map
  const dayToIntegerMap = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  // Function to update the state in the parent component errors
  const handleErrorsValueChange = errors => {
    // Parse the JSON string into an object
    setErrorsTimeslots(errors);
  };

  const handleChangeRating = (category, rating) => {
    setCategoryRatings(prevRatings => ({
      ...prevRatings,
      [category]: rating,
    }));
  };
  const handlefeedback = async (appl_id, status, comments) => {
    await createfeedback(
      appl_id,
      status,
      comments,
      categoryRatings,
      candidateDetails?.round_id
    ).then(res => {
      if (res.status === 200) {
        toast.success(t(`all-application.Feedback Added`));
      } else {
        toast.error(res?.data?.message);
      }
    });
    feedback_close();
    getScreeningList();
  };
  const fetchinterViewers = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/user/fetch-interviewers`, {})
      .then(response => {
        let result = decryptDataFromArray(response.data);
        let { userList, success } = result;
        let data = userList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.id,
        }));
        setinterViewers(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const [errors, setErrors] = useState({});
  const [csvData, setCSVData] = useState([]);
  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");
  const [isCommentRequired, setIsCommentRequired] = useState(true);
  const [isVisibles, setIsVisibles] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  ///hold popup
  const [isSelected, setisSelected] = useState(false);
  const [isHold, setIsHold] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState({});

  // Interview Data
  const [selectedApplId, setSelectedApplId] = useState(null);
  const [isForm2Visible, setIsForm2Visible] = useState(false);
  const [isForm3Visible, setIsForm3Visible] = useState(false);
  const [formDatas, setRescheduleData] = useState({
    int_schedule_date: "",
    int_schedule_time: "",
    f2f_address: "",
  });
  const [formData3, setfeedbackData] = useState({
    comment: "",
  });
  const [InterviewIdForFeedback, setInterviewIdForFeedback] = useState(null);
  const [interviewIdForReschedule, setInterviewIdForReschedule] =
    useState(null);
  const [commentsError, setCommentsError] = useState("");
  const [comments, setComments] = useState(""); // Initialize comment state
  const [offerLetter, setOfferLetter] = useState(null); // Initialize offerLetter state
  const [ctcOffered, setCtcOffered] = useState(0);
  const [ErrorsTimeslots, setErrorsTimeslots] = useState({}); // State to track validation errors

  // Start Assesment
  const [assessmentModal, setAssessmentModal] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [interViewers, setinterViewers] = useState([]);
  const [isAssignedInterviewer, setIsAssignedInterviewer] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState({
    name: "",
    roleType: "",
    user_id: "",
    vacancy_id: "",
    candidate_photo: "",
  });
  const [slotValues, setSlotValues] = useState([
    { label: "09:00 AM - 10:00 AM", value: "09:00 AM - 10:00 AM" },
    { label: "11:00 AM - 12:00 PM", value: "11:00 AM - 12:00 PM" },
    { label: "01:00 PM - 02:00 PM", value: "01:00 PM - 02:00 PM" },
    { label: "02:00 PM - 03:00 PM", value: "02:00 PM - 03:00 PM" },
    { label: "03:00 PM - 04:00 PM", value: "03:00 PM - 04:00 PM" },
    { label: "04:00 PM - 05:00 PM", value: "04:00 PM - 05:00 PM" },
    { label: "05:00 PM - 06:00 PM", value: "05:00 PM - 06:00 PM" },
  ]);

  const initialFormData = {
    int_schedule_date: "",
    int_schedule_time: slotValues[0]?.value,
    interview_title: "",
    interviewer_time: interViewers?.[0]?.value,
    address: "",
    req_documents: "",
    meeting_type: 0,
    teams_interview: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [roundListData, setRoundListData] = useState([]);

  const [testStatus, setTestStatus] = useState("");
  const [interviewStatusFilter, setInterviewStatusFilter] = useState("");
  const [offerLetterStatus, setOfferLetterStatus] = useState("");
  const [feedbackInfo, setFeedbackInfo] = useState("");
  const [readMoreStates, setReadMoreStates] = useState({});

  const [totalCounts, setTotalCounts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);

  const toggleReadMore = id => {
    setReadMoreStates(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const testtatusOptions = [
    { value: "0", label: t(`ATS View.Pending`) },
    { value: "1", label: t(`ATS View.Scheduled`) },
    { value: "2", label: t(`ATS View.Skip`) },
    { value: "3", label: t(`ATS View.On Hold`) },
    { value: "4", label: t(`ATS View.Completed`) },
    { value: "5", label: t(`ATS View.Shortlisted`) },
    { value: "6", label: t(`ATS View.Not Attempted`) },
  ];
  const interviewStatusOptions = [
    { value: "0", label: t(`ATS View.Pending`) },
    { value: "1", label: t(`ATS View.Scheduled`) },
    { value: "2", label: t(`ATS View.Skip`) },
    { value: "3", label: t(`ATS View.On Hold`) },
    { value: "4", label: t(`ATS View.Completed`) },
    { value: "5", label: t(`ATS View.Shortlisted`) },
    { value: "6", label: t(`ATS View.Not Attempted`) },
  ];

  const [roundStatus, setRoundStatus] = useState(null);
  const [isFeedback, setIsFeedback] = useState(false);
  const validateForm = () => {
    let valid = true;
    const newErrors = {};
    // Validate int_schedule_date
    if (!int_start_time) {
      newErrors.int_start_time = t(`all-application.Field required`);
      valid = false;
    }

    // Validate int_schedule_time
    if (!int_end_time) {
      newErrors.int_end_time = t(`all-application.Field required`);
      valid = false;
    }
    // Validate starttime
    if (!selectedStartTime) {
      newErrors.selectedStartTime = t(`all-application.Field required`);
      valid = false;
    }

    // Validate end
    if (!selectedEndTime) {
      newErrors.selectedEndTime = t(`all-application.Field required`);
      valid = false;
    }

    // Create DateTime strings by combining the date and time
    const startDateTime = new Date(
      `${int_start_time.split("T")[0]}T${selectedStartTime}`
    );
    const endDateTime = new Date(
      `${int_end_time.split("T")[0]}T${selectedEndTime}`
    );
    // if (Date.parse(int_start_time) === Date.parse(int_end_time)) {
    //   newErrors.int_end_time =
    //     "End Date & Time and Start Date & Time cannot be the same.";
    //   valid = false;
    // }

    if (Date.parse(startDateTime) - Date.parse(new Date()) < 0) {
      newErrors.startDateTime = t(`all-application.Timeslot err 1`);
      valid = false;
    }
    if (Date.parse(endDateTime) - Date.parse(startDateTime) < 0) {
      newErrors.int_end_time = t(`all-application.Timeslot err 2`);
      valid = false;
    }

    // Check if start date + time is the same as end date + time
    if (startDateTime.getTime() === endDateTime.getTime()) {
      newErrors.int_end_time = t(`all-application.Timeslot err 3`);
      valid = false;
    }

    // Calculate the difference in milliseconds
    const timeDiffMs =
      new Date(endDateTime).getTime() - new Date(startDateTime).getTime();

    // Convert milliseconds to hours
    const timeDiffHours = timeDiffMs / (1000 * 60 * 60); // milliseconds to hours

    // Check if the difference exceeds 3 hours
    if (timeDiffHours > 3) {
      newErrors.int_end_time = t(`all-application.Timeslot err 4`);
      valid = false;
    }

    // Validate interview_title
    if (!formData.interview_title) {
      newErrors.interview_title = t(`all-application.Err 1`);
      valid = false;
    }

    // Validate interviewer_time
    if (!formData.interviewer_time) {
      newErrors.interviewer_time = t(`all-application.Err 2`);
      valid = false;
    }

    // Validate address
    if (!formData.address && formData.meeting_type === 0) {
      newErrors.address = t(`all-application.Err 3`);
      valid = false;
    }
    if (
      !formData.address &&
      formData.meeting_type === 1 &&
      !formData?.teams_interview
    ) {
      newErrors.address = t(`all-application.Err 4`);
      valid = false;
    }

    // Validate req_documents
    // if (!formData.req_documents) {
    //   newErrors.req_documents = "Valid Documents are required";
    //   valid = false;
    // }

    setErrors(newErrors);
    return valid;
  };

  const handleCSVDownload = async e => {
    e.preventDefault();
    try {
      let csvData = [];
      if (isFiltered) {
        let payload = {
          type: "screening",
          gender: gender,
          role: selectedRoleOptions,
          onboarding: onboarding,
          source: source,
          state: state,
          city: city,
          area: area,
          startDate: startDate,
          endDate: endDate,
          testStatus: testStatus,
          interviewStatusFilter: interviewStatusFilter,
          offerLetterStatus: offerLetterStatus,
          pageSize: sizePerPage,
          page: currentPage,
          isCsvDownload: true,
        };
        csvData = await getFilteredList(payload);
      } else {
        csvData = await FetchScreeningList({
          page: currentPage,
          queryText: query,
          pageSize: sizePerPage,
          isCsvDownload: true,
        });
      }

      if (csvData.data.status) {
        csvData = csvData?.data?.data?.map(item => ({
          ...item,
          email_id: generateMaskedPII(item?.email_id),
          mobile: generateMaskedPII(item?.mobile, 2),
        }));
        setCSVData(csvData);
        setTimeout(() => {
          let element = document.getElementById("downloadCSV");
          element.click();
        }, 1000);
        toast.success("File downloaded successfully.");
        setLoading(false);
      } else {
        toast.error(t(`all-application.No data Available`));
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  const getFilterInfo = async () => {
    await FetchFilterInfo()
      .then(res => {
        let filterData = res?.data.data || "";

        if (filterData) {
          setCities(filterData?.cities || []);
          setAreas(filterData?.areas || []);
          setRoleTypes(filterData?.roles || []);
          setSourceType(filterData?.sources || []);
          setStates(filterData?.states || []);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getScreeningList = async (
    current = 1,
    size = 10,
    query_text = "",
    sort_field = sortField,
    sort_order = sortOrder
  ) => {
    setLoading(true);
    await FetchScreeningList({
      page: current,
      queryText: query_text,
      pageSize: size,
      ...(sort_field && { sortField: sort_field, sortOrder: sort_order }),
    })
      .then(res => {
        if (res.data.status) {
          setScreeningData(res.data.data);
          setTotalCounts(res.data.total_counts);
          setLoading(false);
        } else {
          toast.error(t(`all-application.No data Available`));
          setLoading(false);
        }
      })
      .catch(err => {
        toast.error(t(`all-application.No data Available`));
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchinterViewers();
    if (type) {
      handleSubmit();
    } else {
      getScreeningList();
    }
    getFilterInfo();
    document.title = "NeuroTal - Assessment Center";
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedApplId || selectedCandidate?.appl_id) {
        try {
          const res = await getAdminFeedbackData(
            selectedApplId || selectedCandidate?.appl_id
          );
          let responseData = decryptDataFromArray(res);
          setFeedbackInfo(responseData?.data || {});
        } catch (error) {
          console.error("Error fetching feedback data:", error);
        }
      }
    };
    fetchData();
    fetchCandidateNotes();
  }, [selectedApplId, selectedCandidate?.appl_id, assessmentModal]);

  const handleChange = e => {
    setComment(e.target.value);
    setCommentError("");
  };

  const validateComment = () => {
    // if (isCommentRequired && !comment.trim()) {
    //   setCommentError(t(`all-application.Comment required`));
    //   return false;
    // }
    // You can add more validation rules here if needed
    return true;
  };

  const toggleCommentRequirement = () => {
    setIsCommentRequired(prevIsCommentRequired => !prevIsCommentRequired);
  };

  const reject_close = () => {
    setIsHold(false);
    setCommentError("");
  };
  const feedback_close = () => {
    setIsFeedback(false);
  };

  function calculateDaysAgo(applyDate) {
    const applyDateObj = new Date(applyDate);
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = currentDate - applyDateObj;

    // Convert milliseconds to days (1000 ms in a second, 60 seconds in a minute, 60 minutes in an hour, 24 hours in a day)
    const daysAgo = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return daysAgo;
  }

  const handleConfirm = async (
    appl_id,
    status,
    comment,
    new_status = "",
    remark_id = null
  ) => {
    if (isLoading) return;
    if (validateComment()) {
      let otherDetails = {};
      if (new_status) {
        otherDetails = {
          old_status: "In Progress Applications",
          new_status: `${new_status} Applications`,
        };
      }
      setIsLoading(true);
      await updatestatus(appl_id, status, comment, 1, remark_id, otherDetails)
        .then(res => {
          if (res.status === 200) {
            if (status === 5) {
              toast.success(t(`all-application.Record Rejected`));
            } else if (status === 4) {
              toast.success(t(`all-application.Record Onhold`));
            } else {
              toast.success(t(`all-application.Comment Added`));
            }
            getScreeningList();
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      console.log("Validation error:", commentError);
    }
    reject_close();
    closes();
    // window.location.reload();
  };

  const handleStateChange = e => {
    setCity("");
    setState(e.target.value);
    let cityList = cities?.filter(
      el => el?.state_id === parseInt(e.target.value)
    );
    setFilteredCities(cityList);
  };

  const handleGenderChange = e => {
    if (gender === e.target.name) {
      setGender("");
    } else {
      setGender(e.target.name);
    }
  };

  const handleSubmit = (newState, defaultType) => {
    if (!newState) {
      setCurrentPage(1);
      setSizePerPage(10);
    }
    let payload = {
      type: "screening",
      queryText: query,
      gender: gender,
      role: selectedRoleOptions,
      onboarding: onboarding,
      source: source,
      state: state,
      city: city,
      area: area,
      testStatus: testStatus,
      interviewStatusFilter: interviewStatusFilter,
      offerLetterStatus: offerLetterStatus,
      pageSize: 10,
      page: 1,
    };
    if (defaultType || type) {
      payload.startDate = startDate;
      payload.endDate = endDate;
    }
    if (defaultType === "current" || type === "current") {
      payload.startDate = moment().startOf("month").format();
      payload.endDate = moment().endOf("month").format();
      setStartDate(moment().startOf("month").toDate());
      setEndDate(moment().endOf("month").toDate());
    } else if (type === "previous") {
      const start = moment().subtract(3, "months").toDate();
      const end = new Date();
      payload.startDate = moment(start).toISOString();
      payload.endDate = moment(end).toISOString();
      setStartDate(start);
      setEndDate(end);
    }
    const effectiveSortField =
      newState?.sortField !== undefined ? newState.sortField : sortField;
    const effectiveSortOrder =
      newState?.sortOrder !== undefined ? newState.sortOrder : sortOrder;
    const finalPayload = {
      ...(newState || payload),
      ...(effectiveSortField && {
        sortField: effectiveSortField,
        sortOrder: effectiveSortOrder,
      }),
    };
    getFilteredList(finalPayload)
      .then(res => {
        if (res.data.status) {
          setScreeningData(res.data.data);
          setTotalCounts(res.data.total_counts);
          setIsFiltered(true);
        } else {
          toast.error(t(`all-application.No data Available`));
        }
        close();
      })
      .catch(err => console.log(err));
  };

  const clearFilters = () => {
    setGender("");
    setSelectedRoleOptions([]);
    setOnboarding("");
    setArea("");
    setState("");
    setCity("");
    setStartDate("");
    setEndDate("");
    setSource("");
    setTestStatus("");
    setInterviewStatusFilter("");
    setOfferLetterStatus("");
    setCurrentPage(1);
    setSizePerPage(10);
    setIsVisible(false);
    getScreeningList();
    setIsFiltered(false);
    setType("");
  };

  const getFilterList = () => {
    let filterArray = [];

    // Gender filter
    if (gender) {
      filterArray.push({
        label: "Gender",
        value: gender,
        key: "gender",
      });
    }

    // Role filter
    if (selectedRoleOptions?.length > 0) {
      filterArray.push({
        label: "Job Position",
        value: selectedRoleOptions.map(item => item.label).join(", "),
        key: "role",
      });
    }

    // Test Status filter
    if (testStatus) {
      filterArray.push({
        label: "Test Status",
        value: testStatus,
        key: "testStatus",
      });
    }

    // Interview Status filter
    if (interviewStatusFilter) {
      filterArray.push({
        label: "Interview Status",
        value: interviewStatusFilter,
        key: "interviewStatus",
      });
    }

    // Source filter
    if (source) {
      let sourceLabel = sourceType.find(el => el.value == source)?.label;
      filterArray.push({
        label: "Source Type",
        value: sourceLabel,
        key: "source",
      });
    }

    // State filter
    if (state) {
      let stateLabel = states.find(el => el.value == state)?.label;
      filterArray.push({
        label: "State",
        value: stateLabel,
        key: "state",
      });
    }

    // City filter
    if (city) {
      let cityLabel = filteredCities.find(el => el.value == city)?.label;
      filterArray.push({
        label: "City",
        value: cityLabel,
        key: "city",
      });
    }

    // Date Range filter
    if (type) {
      filterArray.push({
        label: t("Date Range"),
        value:
          type === "current"
            ? t("Current Month")
            : type === "previous"
            ? t("Last 3 Months")
            : `Custom (${moment(startDate).format("DD MMM YYYY")} - ${moment(
                endDate
              ).format("DD MMM YYYY")})`,
        key: "type",
      });
    }

    // Offer Letter Status
    if (offerLetterStatus) {
      filterArray.push({
        label: "Offer Letter Status",
        value: offerLetterStatus,
        key: "offerLetterStatus",
      });
    }

    // Onboarding Status
    if (onboarding) {
      filterArray.push({
        label: "Onboarding Status",
        value: onboarding,
        key: "onboarding",
      });
    }

    return filterArray;
  };
  const handleFilterRemove = key => {
    const newState = {
      type: "screening",
      queryText: query,
      gender,
      role: selectedRoleOptions,
      source,
      state,
      city,
      testStatus,
      interviewStatusFilter,
      offerLetterStatus,
      onboarding,
    };

    let defaultType = type;

    switch (key) {
      case "gender":
        setGender("");
        newState.gender = "";
        break;

      case "role":
        setSelectedRoleOptions([]);
        newState.role = [];
        break;

      case "testStatus":
        setTestStatus("");
        newState.testStatus = "";
        break;

      case "interviewStatus":
        setInterviewStatusFilter("");
        newState.interviewStatusFilter = "";
        break;

      case "source":
        setSource("");
        newState.source = "";
        break;

      case "state":
        setState("");
        setCity("");
        newState.state = "";
        newState.city = "";
        break;

      case "city":
        setCity("");
        newState.city = "";
        break;

      case "type":
        setType("");
        setStartDate("");
        setEndDate("");
        newState.startDate = "";
        newState.endDate = "";
        defaultType = "";
        break;

      case "offerLetterStatus":
        setOfferLetterStatus("");
        newState.offerLetterStatus = "";
        break;

      case "onboarding":
        setOnboarding("");
        newState.onboarding = "";
        break;

      default:
        break;
    }

    // Handle date range if type exists
    if (defaultType) {
      newState.startDate = startDate;
      newState.endDate = endDate;
    }

    // Get filtered data with updated filters
    handleSubmit(newState, defaultType);
  };

  const statusUpdateOptions = [
    {
      label: (
        <>
          {/* <FontAwesomeIcon icon={faCircleHalfStroke} />  */}
          <img src={progress_icon} alt="Progress icon" />
          {t(`all-application.In Progress`)}
        </>
      ),
      value: "inProgress",
    },
    {
      label: (
        <>
          <img src={action2} alt="On Hold icon" />{" "}
          {t(`all-application.On Hold`)}
        </>
      ),
      value: "hold",
      disabled: !checkPermissionStatus("screening-list", "onhold"),
    },
    {
      label: (
        <>
          <img src={screening_icon} alt="Selected icon" />{" "}
          {t(`all-application.Selected`)}
        </>
      ),
      value: "selectcandidate",
      disabled:
        localStorage.getItem("subdomain") !== "mahindra"
          ? !checkPermissionStatus("scheduled-list", "selectcandidate")
          : false,
    },
    {
      label: (
        <>
          <img src={action3} alt="Rejected icon" />{" "}
          {t(`all-application.Rejected`)}
        </>
      ),
      value: "reject",
      disabled: !checkPermissionStatus("screening-list", "reject"),
    },
  ];

  const modeColumn = {
    dataField: "Mode",
    text: "Mode",
    classes: "application-normal",
    formatter: (cell, row) => (
      <span>
        <div className="mode-virtual">
          <h3
            className={`${
              row?.roundDetails?.interviewDetails?.meeting_type === 1
                ? "Virtual"
                : "Offline"
            } virtual-span`}
          >
            {row?.roundDetails?.interviewDetails?.meeting_type === 1
              ? "Virtual"
              : "Offline"}
          </h3>
        </div>
      </span>
    ),
  };

  const cityColumn = {
    dataField: "master_city.city",
    text: t(`all-application.City`),
    classes: "application-normal",
  };

  const addressColumn = {
    dataField: "Address",
    text: "Address",
    headerClasses: "application-normal educations",
    classes: "application-normal educations",
    formatter: (cell, row) => {
      let isLink = !!row?.team_link;

      return row?.roundDetails?.interviewDetails?.meeting_type === 1 ? (
        <span
          className="clickable-links met"
          style={isLink ? { cursor: "pointer" } : null}
        >
          <span className="address-icon">
            <img
              src={
                checkMeetingPlatform(row?.team_link) === "Zoom"
                  ? zoom
                  : checkMeetingPlatform(row?.team_link) === "Google Meet"
                  ? gmeet
                  : checkMeetingPlatform(row?.team_link) === "Microsoft Teams"
                  ? teams
                  : row?.f2f_address
                  ? locationma
                  : ""
              }
              alt="Meeting Platform Icon"
            />
          </span>

          {row?.team_link ? (
            <a href={row?.team_link} target="_blank" rel="noopener noreferrer">
              {checkMeetingPlatform(row?.team_link)}
            </a>
          ) : (
            row?.f2f_address || "--"
          )}
        </span>
      ) : (
        <span className="clickable-links met">
          <span className="address-icon">
            <img src={locationma} alt="location icon" />
          </span>
          {row?.f2f_address || "--"}
        </span>
      );
    },
  };

  const columns = [
    {
      dataField: "appl_id",
      text: t(`all-application.Appl No`),
      classes: "total app-col sticky-col",
      headerClasses: "app-col sticky-col",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const formattedDate =
          row.appl_id +
          "/" +
          (applyDate.getMonth() + 1) +
          "" +
          applyDate.getFullYear();
        return (
          <div className="date-tabel">
            <input
              id={`checkbox-input-${row?.appl_id}`} // Unique ID for each input
              type="checkbox"
              className="d-none"
            />
            <label htmlFor={`checkbox-input-${row?.appl_id}`}>
              {formattedDate}
            </label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: t(`all-application.Name`),
      classes: "application-name name-col sticky-col",
      headerClasses: "name-col sticky-col",
      sort: true,
      formatter: (cell, row) => (
        <span
          className="clickable-link"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/candidate_consolidate/view-details/${row.appl_id}`);
          }}
        >
          {cell.toLowerCase()}
        </span>
      ),
    },
    // {
    //   dataField: "email_id",
    //   text: t(`all-application.Email Id`),
    //   classes: "application-email ",
    // },
    // {
    //   dataField: "mobile",
    //   text: t(`all-application.Mobile No`),
    //   classes: "application-normal",
    // },
    {
      dataField: "vacancy.title",
      text: t(`all-application.Job Role`),
      headerClasses: "application-normal education",
      classes: "application-normal",
      sort: true,
    },
      {
      dataField: "vacancy.franchise.franchise_name",
      text: t(`all-application.dealer_name`),
      headerClasses: "application-normal education",
      classes: "application-normal",
      sort: true,
    },
    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`all-application.Education`),
      headerClasses: "application-normal educations",
      classes: "application-normal educations",
      sort: true,
    },
    // {
    //   dataField: "job_user.gender",
    //   text: t(`all-application.Gender`),
    //   classes: "application-normal",
    //   formatter: (cell, row) => {
    //     return t(`Gender.${cell}`);
    //   },
    // },

    {
      dataField: "job_user.total_experience",
      text: t(`all-application.Total Exp`),
      classes: "application-normal",
      sort: true,
    },

    ...(subdomain !== "mahindra" ? [modeColumn] : []),

    {
      dataField: "Date_Time",
      text: "Applied Date & Time",
      classes: "application-name ",
      sort: true,
      formatter: (cell, row) => (
        <span className="clickable-links" style={{ cursor: "pointer" }}>
          <strong>{formatDate(row.apply_date)?.replace(/,.*/, "")}</strong>
          <br /> {formatDate(row.apply_date)?.replace(/^.*,/, "")}
        </span>
      ),
    },
    {
      dataField: "apply_date",
      text: t(`all-application.Applied on`),
      classes: "application-normal",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const today = new Date();
        const isToday = applyDate.toDateString() === today.toDateString(); // Compare date parts only

        const daysAgo = calculateDaysAgo(applyDate);

        return (
          <div className="date-tabel">
            <label>
              {isToday
                ? t(`all-application.Today`)
                : `${daysAgo} ${t(`all-application.days ago`)}`}
            </label>
          </div>
        );
      },
    },

    {
      dataField: "creator.name",
      text: t(`all-application.created_by`),
      classes: "application-normal",
    },

    ...(getSubdomain() !== "mahindra" ? [addressColumn] : []),

    ...(getSubdomain() !== "mahindra" ? [cityColumn] : []),
    {
      dataField: "",
      text: t(`all-application.Status`),
      classes: "Status-normal",
      headerClasses: "Status-normal",
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        let user_id = row?.user_id;
        let vacancy_id = row?.vacancyId;
        return (
          <div
            key={appl_id}
            className="action-application"
            title={`Please select ${t(`all-application.Status`).toLowerCase()}`}
          >
            <label id="select-status-label" className="d-none">
              {t(`all-application.Selected`)}
            </label>{" "}
            <Select
              className="w-100"
              placeholder={t(`all-application.In Progress`)}
              options={statusUpdateOptions}
              onChange={e => {
                handleStatusChange(e, appl_id);
              }}
              value={""}
              isOptionDisabled={option => option?.disabled}
              tabIndex={1} // Ensuring a positive tabindex value
              aria-labelledby="select-status-label"
            />
          </div>
        );
      },
    },
    {
      dataField: "",
      text: t(`all-application.Actions`),
      classes: "total text-center Actions-acrd",
      headerClasses: "text-center  Actions-acrd",
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        let user_id = row?.user_id;
        let vacancy_id = row?.vacancyId;
        let created_time = row?.apply_date;
        return (
          <div className="action-application  gap-space-assement">
            <div className="action-ones">
              <Button
                className="blue-color"
                onClick={() =>
                  handleAssessmentStart(
                    vacancy_id,
                    user_id,
                    appl_id,
                    row?.name,
                    row?.vacancy?.title,
                    created_time,
                    row
                  )
                }
              >
                {subdomain !== "mahindra" ? (
                  <>
                    {row?.roundDetails?.roundName
                      ? `${row?.roundDetails?.roundName} [${row?.roundDetails?.roundStatus}]`
                      : t(`all-application.In Progress`)}
                    <img src={edit_icon} alt="edit" />
                  </>
                ) : (
                  <>
                    {t("all-application.View")}
                    <FontAwesomeIcon icon={faEye} />
                  </>
                )}
              </Button>
            </div>
            {/* <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={threedots} alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("screening-list", "view")}
                    onClick={() => {
                      history.push(
                        `/candidate_consolidate/view-details/${appl_id}`
                      );
                    }}
                  >
                    {t(`all-application.View Details`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
          </div>
        );
      },
    },
  ];

  const handleStatusChange = async (e, appl_id) => {
    const action = e?.value;

    if (action === "hold") {
      await handleConfirm(
        appl_id,
        STATUS_MAP.hold.code,
        "",
        STATUS_MAP.hold.label
      );
    } else if (["reject", "shortlist", "selectcandidate"].includes(action)) {
      open_slider(appl_id, STATUS_MAP[action].code, null, action);
    }
  };
  const filter_icon = () => {
    setIsVisible(!isVisible);
  };

  const close = () => {
    setIsVisible(false);
    setCommentError("");
  };

  const closes = () => {
    setIsReject(false);
    setCommentError("");
  };

  const getRoundIsOnlineOeOff = roundName => {
    let roundInfo = roundListData.filter(el => el?.roundName == roundName);
    return roundInfo[0]?.interviewDetails?.meeting_type;
  };

  const open_slider = async (appl_id, status, round_id, type) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/common/fetch-details/${appl_id}`
      );
      const data = response.data;

      if (data.status && data.data.length > 0) {
        setCandidateDetails({
          ...data?.data[0],
          round_id: round_id,
        });
      } else {
        console.error("Invalid data format received from API:", data);
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }

    if (type != null && status !== 3) {
      console.log(type, status, "type");
      setSelectedApplId(appl_id);
      setActionType(type);
      setIsReject(true);
    } else {
      if (status == 1) {
        setIsHold(!isVisibles);
      } else if (status == 2) {
        setIsReject(!isReject);
      } else if (status == 3) {
        setisSelected(!isVisibles);
      } else if (status == 8) {
        handleCloseAssessmentModal();
        setIsFeedback(!isFeedback);
      }
    }
  };

  const handleAssessmentStart = async (
    vacancy_id,
    user_id,
    appl_id,
    name,
    roleType,
    created_time,
    allInfo
  ) => {
    setRoundStatus(null);
    setAssessmentModal(true);
    setSelectedApplId(appl_id);
    const date = new Date(created_time);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
      date
    );
    setSelectedCandidate({
      name: name,
      roleType: roleType,
      user_id: user_id,
      vacancy_id: vacancy_id,
      appl_id: appl_id,
      createdAt: formattedDate,
      allInfo: allInfo,
      candidate_photo: allInfo?.job_user?.candidate_photo,
    });
    let payload = {
      appl_id: appl_id,
      // vacancy_id: vacancy_id,
      // user_id: user_id,
    };
    await fetchRoundsData(payload);
  };
  const fetchRoundsData = async payload => {
    setLoading(true);
    await fetchNextRoundData(payload)
      .then(res => {
        if (res?.data?.success) {
          setLoading(false);
          setRoundListData(res?.data?.data || []);
        } else {
          setLoading(false);
          toast.error(t(`all-application.No data Available`));
        }
      })
      .catch(err => console.log(err));
  };

  const handleToggleForm = () => {
    setIsFormVisible(prev => !prev);
  };

  const handleInterviewModal = (
    roundId,
    roundType,
    roundName,
    roundStatus,
    meeting_type,
    interviewed_id,
    itr_type,
    itr_details,
    passedAssignedInterviewerId
  ) => {
    setAssessmentModal(false);
    setInterviewType(itr_type);

    meeting_type = getRoundIsOnlineOeOff(roundName) || 0;

    const assignedInterviewerId =
      passedAssignedInterviewerId ||
      itr_details?.interviewDetails?.user?.id ||
      itr_details?.interviewDetails?.interviewer_id ||
      itr_details?.user?.id ||
      itr_details?.interviewer_id ||
      itr_details?.interviewer?.id ||
      itr_details?.interviewer?.user?.id ||
      null;

    const isCurrentUserAssigned =
      assignedInterviewerId !== null &&
      assignedInterviewerId !== undefined &&
      Number(assignedInterviewerId) === Number(userloggedinId);

    setIsAssignedInterviewer(isCurrentUserAssigned);
    /*
     * Find interviewer from interviewer API list.
     */
    const assignedInterviewer = interViewers?.find(interviewer => {
      const interviewerId = interviewer?.id ?? interviewer?.value;

      return Number(interviewerId) === Number(assignedInterviewerId);
    });

    console.log("assignedInterviewer:", assignedInterviewer);

    /*
     * ================================
     * SCHEDULE
     * ================================
     */
    if (itr_type === "schedule") {
      let interviewerValue = "0";

      if (assignedInterviewerId) {
        /*
         * Existing assigned interviewer.
         */
        interviewerValue = String(
          assignedInterviewer?.value || assignedInterviewerId
        );
      }

      setFormData({
        interviewer_time: interviewerValue,
        address: "",
        req_documents: "",
        meeting_type: meeting_type,
        teams_interview: false,
        roundId: roundId,
        roundType: roundType,
        interview_title: roundName,
        roundStatus: roundStatus,
      });
    } else {
      /*
       * ================================
       * RESCHEDULE
       * ================================
       */
      const existingInterviewerId =
        itr_details?.interviewDetails?.user?.id ||
        itr_details?.interviewDetails?.interviewer_id ||
        assignedInterviewerId ||
        null;

      const interviewer = interViewers?.find(el => {
        const interviewerId = el?.id ?? el?.value;

        return Number(interviewerId) === Number(existingInterviewerId);
      });

      console.log("existingInterviewerId:", existingInterviewerId);

      console.log("reschedule interviewer:", interviewer);

      setFormData({
        interviewer_time: interviewer?.value || existingInterviewerId || "0",

        address: "",
        req_documents: "",
        meeting_type: meeting_type,
        teams_interview: false,

        roundId: roundId,
        roundType: roundType,
        interview_title: roundName,
        roundStatus: roundStatus,

        itr_id: itr_details?.interviewDetails?.id,
      });
    }

    /*
     * Store the assignment information on the modal
     * using formData itself.
     */
    setIsFormVisible(prev => !prev);
  };

  const handleScreenTest = async (
    round_id,
    appl_id,
    user_id,
    vacancy_id,
    status
  ) => {
    try {
      const confirmed = window.confirm(
        t(`all-application.Send link confirmation`)
      );

      if (!confirmed) {
        return;
      }
      let authUser = JSON.parse(localStorage.getItem("authUser"));
      let adminId = authUser.user.id;
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/pending/update-screening`,
        {
          round_id,
          appl_id: selectedCandidate?.appl_id || "",
          user_id,
          vacancy_id,
          status,
          adminId,
        },
        {}
      );

      if (response.status === 200) {
        toast.success(t(`all-application.Send link successful`));
        fetchRoundsData({ appl_id: selectedCandidate?.appl_id });
      } else {
        toast.error(t(`all-application.Send link fail`));
      }
      // handleCloseAssessmentModal();
    } catch (error) {
      toast.error("Error: " + error.message);
    }
  };
  const handleCloseAssessmentModal = () => {
    setAssessmentModal(!assessmentModal);
  };

  const handleToggleForm2 = interviewId => {
    setInterviewIdForReschedule(interviewId);
    setIsForm2Visible(prev => !prev);
  };

  const handleToggleFeeddback = interviewId => {
    setInterviewIdForFeedback(interviewId);
    setIsForm3Visible(prev => !prev);
  };

  const handleRescheduleSubmit = async e => {
    e.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const startDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_start_time)
    ).format("YYYY-MM-DD")}T${selectedStartTime}`;
    const endDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_end_time)
    ).format("YYYY-MM-DD")}T${selectedEndTime}`;

    const dynamicInterviewId = interviewIdForReschedule;

    let ChangedEventDate = moment(
      getCompanyTimezoneDateTime(startDateTimeString)
    ).utc();
    let ChangedEndEventDate = moment(
      getCompanyTimezoneDateTime(endDateTimeString)
    ).utc();

    let newFormData = JSON.parse(JSON.stringify(formData));

    const dynamicApplId = newFormData?.itr_id;
    const formattedDate = convertDateFormat(ChangedEventDate);
    newFormData.int_schedule_date = formattedDate;
    newFormData.int_start_time = ChangedEventDate;
    newFormData.int_end_time = ChangedEndEventDate;
    newFormData.time_zone_id = userInfo?.company_time_zone_id;
    let device_info = await getDeviceInfo(navigator);
    let roundItem = roundListData?.find(el => el?.isCurrentRound);
    newFormData = {
      ...newFormData,
      device_info: device_info,
      old_status: roundItem?.roundName + " - " + roundItem?.roundStatus,
      new_status: roundItem?.roundName + " - Rescheduled",
      appl_id: selectedApplId,
    };
    try {
      setIsLoadingSchedule(true);
      api.post(
        `${process.env.REACT_APP_API_URL}/admin/schedule/update-reschedule/${dynamicApplId}`,
        newFormData
      );

      toast.success(t(`all-application.Interview Rescheduled`));
      setIsFormVisible(false);
      fetchRoundsData({ appl_id: selectedApplId });
      clearDtTime();
      setIsLoadingSchedule(false);
    } catch (error) {
      setIsLoadingSchedule(false);
      toast.error(t(`all-application.Error rescheduling interview`));
    }
  };

  const changeHandlersV2 = e => {
    setRescheduleData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCloseModal = () => {
    setShowNotes(!showNotes);
  };

  const handlefeedbackSubmit = async e => {
    e.preventDefault();
    const feedbackid = InterviewIdForFeedback;
    // console.log("feedback" + feedbackid);
    setfeedbackData(prevData => ({
      ...prevData,
    }));
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/schedule/update-feedback/${feedbackid}`,
        formData3
      );
      toast.success(t(`all-application.Feedback Submitted`));
    } catch (error) {
      toast.error(t(`all-application.Error rescheduling interview`));
    }
    setIsForm3Visible(false);
  };

  const changecomment = e => {
    setfeedbackData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const validateComments = () => {
    if (!comments.trim()) {
      setCommentsError(t(`all-application.Comment required`));
      return false;
    }
    // You can add more validation rules here if needed
    setCommentsError("");
    return true;
  };

  const handleSelected = async (appl_id, user_id) => {
    if (isLoadingSchedule) return;
    if (!offerLetter) {
      setOfferLetterError("Offer letter is required");
      toast.error("Offer letter is required");
      return;
    }
    if (validateComments()) {
      let formData = new FormData();
      let device_info = await getDeviceInfo(navigator);
      formData.append("offer_letter", offerLetter);
      formData.append("ctc_offered", ctcOffered);
      formData.append("comments", comments);
      formData.append("status_change_from", "2");
      formData.append("status", "3");
      formData.append("user_id", user_id);
      formData.append("old_status", "In Progress Applications");
      formData.append("new_status", "Selected Applications");
      formData.append("device_info", JSON.stringify(device_info));
      setIsLoadingSchedule(true);
      await updateselected(appl_id, formData)
        .then(res => {
          if (res.status === 200) {
            getScreeningList();
            toast.success("Offer letter sent Successfully.");
          } else {
            toast.error(res?.data?.message);
          }

          // window.location.reload();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setIsLoadingSchedule(false);
        });
      selected_close();
    } else {
      console.log("Validation error:", commentError);
    }
  };

  const selected_close = () => {
    setisSelected(false);
    setCommentsError("");
  };

  // Fetch time slots based on interviewerID
  const fetchInterTimeslot = async (interviewer_id, date, type) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/user/fetch-timeslots/${interviewer_id}?date=${date}`,
        {}
      );

      const result = response.data;
      const { user } = result;
      const { timeSlots, bookedTimeSlots, timeSlotsData } = user;
      settimeSlotsData(timeSlotsData || {});
      if (Array.isArray(timeSlots)) {
        if (type === "start") {
          // Extract start times for the start time dropdown
          const startTimes = timeSlots.map(slot => slot.startTime);
          setsDateTimeSlots(startTimes); // Update start time slots state
        } else if (type === "end") {
          // Filter end times based on the selected start time
          const filteredTimeSlots = timeSlots.filter(slot =>
            moment(slot.startTime, "HH:mm").isSameOrAfter(
              moment(selectedStartTime, "HH:mm")
            )
          );

          if (filteredTimeSlots.length > 0) {
            const endTimes = filteredTimeSlots.map(slot => slot.endTime);
            seteDateTimeSlots(endTimes); // Update end time slots state
          } else {
            seteDateTimeSlots([]); // No available end time slots
            toast.error(t(`all-application.Timeslot err 5`));
          }
        }
      } else {
        console.error("timeSlots is not an array:", timeSlots);
      }
    } catch (error) {
      console.error("Error fetching time slots:", error);
    }
  };

  const clearDtTime = () => {
    setsDateTimeSlots([]);
    seteDateTimeSlots([]);
    setStartTime("");
    setEndTime("");
    setSelectedStartTime("");
    setSelectedEndTime("");
    setIsTimeslotBtnDisabled(true);
  };
  const handleDateChange = (date, type) => {
    let valid = true;
    const formattedDate = moment(getCompanyTimezoneDateTime(date)).format(
      "YYYY-MM-DD"
    );
    if (formData?.interviewer_time === "0") {
      clearDtTime();
      toast.error(t(`all-application.Please select Interviewer`));
      return false;
    }

    if (type === "start") {
      setSelectedStartTime("");
      setSelectedEndTime("");
      setEndTime("");
      setStartTime(formattedDate); // Update the start date
    } else if (type === "end") {
      setSelectedEndTime("");
      // Check if start date and start time are set before setting the end time
      if (!int_start_time) {
        toast.error(t(`all-application.Please select start date`));
        return false;
      }
      if (!selectedStartTime) {
        toast.error(t(`all-application.Please select start time`));
        return false;
      }
      setEndTime(formattedDate); // Set end date
    }
    const interviewerID = formData?.interviewer_time || 0;
    fetchInterTimeslot(interviewerID, formattedDate, type);
    // Enable button if interviewer_time is greater than zero
    setIsTimeslotBtnDisabled(interviewerID <= 0);
  };

  // Usage
  const handleStartDateChange = date => handleDateChange(date, "start");
  const handleEndDateChange = date => handleDateChange(date, "end");

  const handleUpdateRoundStatus = async (
    id,
    roundId,
    old_status,
    roundName,
    roundType,
    user_id,
    vacancy_id
  ) => {
    if (!roundStatus) {
      toast.error(t(`all-application.Round Status Required`));
      return false;
    }
    let payload = {
      roundType: roundType,
      appl_id: selectedApplId,
      intr_id: id,
      status: roundStatus,
      roundId: roundId,
      old_status: roundName + " - " + old_status,
      new_status: roundName + " - " + getInterviewStatus(roundStatus),
      user_id: user_id,
      vacancy_id: vacancy_id,
    };
    await updateRoundStatus(payload)
      .then(res => {
        fetchRoundsData({ appl_id: selectedApplId });
        toast.success(t(`all-application.Round Status Updated`));
      })
      .catch(err => {
        let errMsg =
          err?.response?.message ||
          err?.response?.data?.msg ||
          t(`all-application.Something Went Wrong`);
        toast.error(errMsg);
      });
  };

  const fetchCandidateNotes = async () => {
    if (!selectedApplId) {
      return;
    }
    await getCandidateNotes(selectedApplId)
      .then(res => {
        setAllNotes(res?.data || []);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  const handleRemoveNote = async item => {
    if (!selectedApplId || !item) {
      return;
    }
    if (item?.admin_id !== userInfo?.id) {
      toast.warn(
        t(`View Details.Notes can only be modified by admin who created it!`)
      );
      return;
    }
    await removeCandidateNotes(selectedApplId, { noteId: item?.id })
      .then(res => {
        toast.success(t(`View Details.Note Removed Successfully!`));
        fetchCandidateNotes();
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 7) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (screeningData.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [screeningData.length]);

  const convertDateFormat = dateString => {
    // Create a new Date object from the given date string
    const dateObject = new Date(dateString);

    // Extract year, month, and day from the date object
    const year = dateObject.getFullYear();
    // Months are zero-based, so we add 1 to get the correct month
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    // Construct the formatted date string
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const handleInterviewSubmit = async e => {
    e.preventDefault(); // Prevent the default form submission behavior

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const startDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_start_time)
    ).format("YYYY-MM-DD")}T${selectedStartTime}`;
    const endDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_end_time)
    ).format("YYYY-MM-DD")}T${selectedEndTime}`;

    let ChangedEventDate = moment(
      getCompanyTimezoneDateTime(startDateTimeString)
    ).utc();
    let ChangedEndEventDate = moment(
      getCompanyTimezoneDateTime(endDateTimeString)
    ).utc();

    const dynamicApplId = selectedApplId;
    const user_id = selectedCandidate?.user_id || "";
    let newFormData = JSON.parse(JSON.stringify(formData));
    const formattedDate = convertDateFormat(ChangedEventDate);
    newFormData.int_schedule_date = formattedDate;
    newFormData.int_start_time = ChangedEventDate;
    newFormData.int_end_time = ChangedEndEventDate;
    newFormData.time_zone_id = userInfo?.company_time_zone_id;
    let device_info = await getDeviceInfo(navigator);
    newFormData = {
      ...newFormData,
      device_info: device_info,
      old_status:
        newFormData?.interview_title + " - " + newFormData?.roundStatus,
      new_status: newFormData?.interview_title + " - Scheduled",
    };
    try {
      setIsLoadingSchedule(true);
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/screening/schedule-interview/${dynamicApplId}/${user_id}`,
        newFormData
      );
      toast.success(t(`all-application.Interview Scheduled`));
      getScreeningList();
      handleToggleForm();
      setAssessmentModal(false);
      clearDtTime();
      setIsLoadingSchedule(false);
    } catch (error) {
      setIsLoadingSchedule(false);
      setAssessmentModal(false);
      toast.error(t(`all-application.Error submitting form`));
    }
  };

  const changeHandlers = e => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
    setErrors({
      ...errors,
      [e.target.name]: "",
    });

    // Conditionally call clearDtTime for specific fields
    if (name === "interviewer_time") {
      clearDtTime();
      setIsTimeslotBtnDisabled(true); // Disable Add TimeSlots button
      setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin
    } else {
      // Enable the button if interviewer_time is valid
      const interviewerID = formData?.interviewer_time || 0;
      setIsTimeslotBtnDisabled(interviewerID <= 0);
    }
  };

  // Handle start time selection
  const handleStartTimeChange = time => {
    const selectedDate = new Date(int_start_time); // Date selected in DatePicker
    const [hours, minutes] = time.split(":");

    // Clone the selected date and set the selected time
    const selectedTime = new Date(selectedDate);
    selectedTime.setHours(hours);
    selectedTime.setMinutes(minutes);

    const currentDateTime = new Date(); // Get current date and time

    // Check if the selected start date is today
    const isToday =
      selectedDate.toDateString() === currentDateTime.toDateString();

    // Only perform the "must be in the future" validation if today is selected
    if (isToday && selectedTime <= currentDateTime) {
      // Set an error if the selected time is invalid and today is selected
      setErrors(prevErrors => ({
        ...prevErrors,
        selectedStartTime: t(`all-application.Selected time in future`),
      }));
    } else {
      // Clear the error if the time is valid or if the date is not today
      setErrors(prevErrors => ({
        ...prevErrors,
        selectedStartTime: "", // Clear the specific error for the start time
      }));

      // Update the state for selected time and reset end time slots
      setSelectedStartTime(time);
      seteDateTimeSlots([]); // Reset end time slots
      setEndTime(""); // Reset end time
      setSelectedEndTime(""); // Reset selected end time
    }
  };

  const handleEndTimeChange = e => {
    const selectedEnd = e.target.value;
    setSelectedEndTime(selectedEnd);

    if (selectedStartTime) {
      // Helper function to parse time
      const parseTime = time => {
        const [hours, minutes] = time.split(":").map(Number);
        const today = new Date();
        return new Date(today.setHours(hours, minutes, 0, 0)); // Set time to today's date
      };

      const startTime = parseTime(selectedStartTime);
      const endTime = parseTime(selectedEnd);
      const now = new Date(); // Current date and time

      // Check if the selected start date is today
      const selectedDate = new Date(int_start_time); // Assuming int_start_time is the selected start date
      const isToday = selectedDate.toDateString() === now.toDateString();

      // Validation: End time cannot be in the past or present only if today is selected
      if (isToday && endTime <= now) {
        setSelectedEndTime("");
        toast.error(t(`all-application.Timeslot err 6`));
        return;
      }

      // Validation: End time must be after the selected start time
      if (endTime <= startTime) {
        setSelectedEndTime("");
        toast.error(t(`all-application.Timeslot err 7`));
        return;
      }

      // Check for overlap with booked time slots
      const hasOverlap = bookedTimeSlots.some(slot => {
        const bookedStart = parseTime(slot.startTime);
        const bookedEnd = parseTime(slot.endTime);

        return startTime < bookedEnd && endTime > bookedStart;
      });

      if (hasOverlap) {
        setSelectedEndTime("");
        toast.error(t(`all-application.Timeslot err 8`));
        return;
      }

      // If validation passes, update formData
      setFormData(prevFormData => ({
        ...prevFormData,
        int_schedule_time: `${selectedStartTime} - ${selectedEnd}`,
      }));
    }
  };

  const handleTimeslotSubmit = event => {
    event.preventDefault();

    setErrors({});
    let errorObj = {};
    const errorMessages = [];

    let payload = new FormData();

    const mappedTimeSlots = Object.fromEntries(
      Object.entries(daytimeSlots)
        .map(([day, slots]) => {
          const integerKey = dayToIntegerMap[day];
          if (integerKey === undefined) return;
          return [integerKey, slots];
        })
        .filter(entry => entry !== undefined)
    );

    const timeSlotsobj = JSON.stringify(mappedTimeSlots, null, 2);

    payload.append("timeSlots", timeSlotsobj);

    // Log the FormData contents
    payload.forEach((value, key) => {});

    // Loop through each day in the ErrorsTimeslots object and extract the messages
    for (const [day, messages] of Object.entries(ErrorsTimeslots)) {
      // Check if the day contains any messages
      if (Array.isArray(messages) && messages.length > 0) {
        errorObj[day] = messages; // Keep track of errors per day
        // Push all non-empty error messages for the day into errorMessages
        messages.forEach(message => {
          if (message && message.trim() !== "") {
            // Check if message is not empty or only whitespace
            errorMessages.push(`${day}: ${message}`);
          }
        });
      } else {
        // If no messages, remove the day from ErrorsTimeslots
        delete ErrorsTimeslots[day];
      }
    }

    // Display the error messages, for example using toast
    if (errorMessages.length > 0) {
      toast.error(errorMessages.join("\n")); // Display each error on a new line
      setErrors(errorObj); // Set the error state for the form
      setIsLoading(false);
    } else {
      // Proceed to call the API if the payload is correct
      updateUserTimeslots(payload);
    }
  };

  // Function to update user
  const updateUserTimeslots = payload => {
    const userId = formData?.interviewer_time || 0;
    if (!userId || userId === "0") {
      console.error("Invalid userId.");
      return; // Exit the function if userId is invalid
    }

    api
      .patch(
        `${process.env.REACT_APP_API_URL}/admin/user/update-usertimeslots/${userId}`,
        payload,
        {}
      )
      .then(response => {
        setIsLoading(false);
        setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin after success
        clearDtTime();

        // Show success toast
        toast.success(t(`all-application.Timeslots updated`));
      })
      .catch(err => {
        setIsLoading(false);
        console.log("Error:", err);

        // Show error toast (optional)
        toast.error(t(`all-application.Update timeslots failed`));
      });
  };

  const handleAddTimeslotsClick = e => {
    e.preventDefault(); // Prevent the default form submission behavior
    setShowTimeslotBooking(true); // Show TimeslotBookingAdmin when the button is clicked
  };

  const handleCancelClick = e => {
    e.preventDefault(); // Prevent default behavior
    setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  //mobileview
  const tableWrapperRef1 = useRef(null);
  const handleScroll1 = direction => {
    if (tableWrapperRef1.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef1.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const tabWrapperRef = useRef(null);

  const scrollLeft = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = isLang1OrLang2 ? 30 : 20; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1280) {
      moveDistance = isLang1OrLang2 ? 30 : 20;
    } else if (window.innerWidth < 1280) {
      moveDistance = isLang1OrLang2 ? 60 : 50;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(${moveDistance}px)`;
    }
  };

  const scrollRight = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = 150; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth >= 1280) {
      // Adjust based on lang-1 or lang-2
      if (bodyClassList.contains("lang-1")) {
        moveDistance = 380; // For lang-1
      } else if (bodyClassList.contains("lang-2")) {
        moveDistance = 100; // For lang-2
      } else {
        moveDistance = 380; // Default for 1280px+
      }
    } else if (window.innerWidth >= 1152) {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    } else {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(-${moveDistance}px)`;
    }
  };

  const handleActionSubmit = () => {
    if (!STATUS_MAP[actionType]) {
      console.error("Invalid action type:", actionType);
      return;
    }

    const trimmedComment = comment.trim();

    if (actionType === "reject") {
      if (!selectedRemark) {
        setCommentError("Please select rejection reason");
        return;
      }

      if (selectedRemark.is_comment_required && !trimmedComment) {
        setCommentError("Comment is required");
        return;
      }
    }

    if (actionType !== "reject" && isCommentRequired && !trimmedComment) {
      setCommentError("Comment is required");
      return;
    }

    setCommentError("");

    handleConfirm(
      candidateDetails.appl_id,
      STATUS_MAP[actionType].code,
      trimmedComment,
      STATUS_MAP[actionType].label,
      selectedRemark?.id || null
    );
  };

  const getAssesmentLink = async (
    round_id,
    appl_id,
    user_id,
    vacancy_id,
    status
  ) => {
    try {
      let authUser = JSON.parse(localStorage.getItem("authUser"));
      let adminId = authUser.user.id;
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/pending/getAssesmentLink`,
        {
          round_id,
          appl_id: selectedCandidate?.appl_id || "",
          user_id,
          vacancy_id,
          status,
          adminId,
        },
        {}
      );
      if (response?.status === 200) {
        window.open(`${response?.data?.Url}&type=interviewer`, "_blank");
      } else {
        toast.error(t(`all-application.Send link fail`));
      }
      // handleCloseAssessmentModal();
    } catch (error) {
      toast.error("Error: " + error.message);
    }
  };

  // Copy Link
  const handleCopyLink = async linkToCopy => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      toast.success("The link has been copied to your clipboard!");
    } catch (error) {
      toast.error("Unable to copy the link");
      console.error("Failed to copy text: ", error);
    }
  };

  const [isFocused, setIsFocused] = useState(false);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  //tabs
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const [showModal, setShowModal] = useState(false);
  const [showNotes, setShowNotes] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleNotes = () => setShowNotes(!showNotes);

  const handleClose = () => {
    setShowModal(false);
    setAssessmentModal(false);
  };

  useEffect(() => {
    if (showModal) {
      setAssessmentModal(false);
    }
  }, [showModal]);

  const handleTableChange = (
    type,
    { page, sizePerPage: ps, sortField: sf }
  ) => {
    if (type === "sort") {
      const newOrder =
        sf === sortField ? (sortOrder === "asc" ? "desc" : "asc") : "asc";
      setSortField(sf);
      setSortOrder(newOrder);
      setCurrentPage(1);
      if (isFiltered) {
        handleSubmit(
          {
            type: "screening",
            gender,
            role: selectedRoleOptions,
            onboarding,
            source,
            state,
            city,
            area,
            startDate,
            endDate,
            testStatus,
            interviewStatusFilter,
            offerLetterStatus,
            pageSize: ps || sizePerPage,
            page: 1,
            sortField: sf,
            sortOrder: newOrder,
          },
          ""
        );
      } else {
        getScreeningList(1, ps || sizePerPage, query, sf, newOrder);
      }
    } else {
      setCurrentPage(page);
      setSizePerPage(ps);
      if (isFiltered) {
        handleSubmit(
          {
            type: "screening",
            gender,
            role: selectedRoleOptions,
            onboarding,
            source,
            state,
            city,
            area,
            startDate,
            endDate,
            testStatus,
            interviewStatusFilter,
            offerLetterStatus,
            pageSize: ps,
            page,
            ...(sortField && { sortField, sortOrder }),
          },
          ""
        );
      } else {
        getScreeningList(page, ps, query, sortField, sortOrder);
      }
    }
  };

  const handleSearch = async () => {
    handleSubmit();
    setCurrentPage(1);
  };

  if (!checkPermissionStatus("screening-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`all-application.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="pending-list-page">
        <div className="tabbing-wrapper allap d-flex justify-content-between mt-2 mb-4 position-relative">
          <button className="arrow-btns" onClick={scrollLeft}>
            <img src={right_arrow} alt="left-arrow" />
          </button>
          <button className="arrow-btns right" onClick={scrollRight}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            <ul
              className="tab-btn-wrapper d-flex align-items-center"
              ref={tabWrapperRef}
              style={{ transition: "transform 0.3s" }}
            >
              <li>
                <Link
                  to={`/all-applications${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="all-applications"
                >
                  {t(`all-application.All Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/pending-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="pending-list"
                >
                  {t(`all-application.New Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/screening-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link active"
                  id="screening-list"
                >
                  {t(`all-application.In Progress Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/selected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="selected-list"
                >
                  {t(`all-application.Selected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onboarded-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onboarded-list"
                >
                  {t(`all-application.Onboarded Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onhold-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onhold-list"
                >
                  {t(`all-application.Onhold Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/rejected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="rejected-list"
                >
                  {t(`all-application.Rejected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/archive-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="archive-list"
                >
                  {t(`all-application.Archived Applications`)}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* <div className="outerTab-box-wrapper applicationcard-table screeningtest"> */}
        <div className="outerTab-box-wrapper applicationcard-table mobile-cards-view allapp-cation">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            ></div>
            <div className="tabel-application table-responsive pb-3">
              <div className="table-data-search">
                <div className="total-record">
                  <h5>
                    {t(`all-application.Total Records`)}{" "}
                    <span>{totalCounts || 0}</span>
                  </h5>
                </div>
                <div className="total-serachbar">
                  <SearchBar
                    onSearch={handleSearch}
                    title={t(`all-application.Search by mobile2`)}
                    placeholder={
                      t(`all-application.Search by mobile`).slice(0, 40) + "..."
                    }
                    query={query}
                    setQuery={setQuery}
                  />
                  {checkPermissionStatus("screening-list", "downloadcsv") && (
                    <div className="take-text">
                      <CSVLink
                        data={csvData}
                        headers={[
                          {
                            key: "appl_id",
                            label: t(`all-application.Application ID`),
                          },
                          {
                            key: "name",
                            label: t(`all-application.Name`),
                          },
                          {
                            key: "mobile",
                            label: t(`all-application.Mobile Number`),
                          },

                          {
                            key: "email_id",
                            label: t(`all-application.Email ID`),
                          },
                          {
                            key: "createdAt",
                            label: t(`all-application.Created Date`),
                          },
                          {
                            key: "f2f_address",
                            label: t(`all-application.Address`),
                          },
                        ]}
                        filename={`ScreeningApplicationList.csv`}
                        id="downloadCSV"
                      >
                        <Button
                          color="info"
                          onClick={e => handleCSVDownload(e)}
                          outline
                          className="btn btn-outline-info"
                        >
                          <img src={dowanload_csv} alt="Download" />{" "}
                          {t(`all-application.Download CSV`)}
                        </Button>
                      </CSVLink>
                    </div>
                  )}

                  <div className="take-text filter" onClick={filter_icon}>
                    <h5>
                      <span>
                        <img src={filtericon} alt="filter icon" />
                      </span>
                      {t(`all-application.Filters`)}
                    </h5>
                  </div>

                  <div className="tale-text right-panel alapp arrow-btns">
                    <button
                      className="button left"
                      onClick={() => handleScroll("left")}
                      data-tooltip="Scroll Left"
                    >
                      <img src={right_arrow} alt="left-arrow" />
                    </button>
                    <button
                      className="button right"
                      onClick={() => handleScroll("right")}
                      data-tooltip="Scroll Right"
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                  </div>
                </div>
              </div>

              {getFilterList()?.length > 0 && (
                <div className="selected-data-card length-selected-data allapp mb-4">
                  {getFilterList()?.map((el, index) => {
                    return (
                      <div className="select-para" key={index}>
                        <p className="mb-0">
                          <span className="selected-tag text-capitalize">
                            {el?.label} - {el?.value}
                          </span>
                          <button
                            className="remove-tag-button"
                            onClick={() => handleFilterRemove(el?.key)}
                          >
                            &times;
                          </button>
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="timeto-hire-card userlist pendiglist-cardss">
                {loading && (
                  <div className="m-3 p-3 text-center">
                    <Spinner size={"lg"} />{" "}
                    <div>{t(`all-application.Loading`)}</div>
                  </div>
                )}
                {!loading && (
                  <div className="table-custome-class range-custome">
                    {screeningData.length > 0 ? (
                      <>
                        <div className="scroll-container">
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <RemotePagination
                              keyField="appl_id"
                              data={screeningData}
                              columns={columns}
                              page={currentPage}
                              sizePerPage={sizePerPage}
                              totalSize={totalCounts}
                              onTableChange={handleTableChange}
                              rowClasses={rowClasses}
                              sortField={sortField}
                              sortOrder={sortOrder}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <table className="table table-hover table-bordered">
                        <thead>
                          <tr>
                            <th>{t(`all-application.Appl No`)}</th>
                            <th>{t(`all-application.Name`)}</th>
                            <th>{t(`all-application.Email Id`)}</th>
                            <th>{t(`all-application.Mobile No`)}</th>
                            <th>{t(`all-application.Gender`)}</th>
                            <th>{t(`all-application.Education`)}</th>
                            <th>{t(`all-application.Total Exp`)}</th>
                            <th>{t(`all-application.Job Role`)}</th>
                            <th>{t(`all-application.City`)}</th>
                            <th>{t(`all-application.Actions`)}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan="10" className="text-center">
                              <div className="no-data data-available">
                                <img
                                  src="../img/data-not-available.png"
                                  alt="data not availble"
                                />
                                <h3>{t(`all-application.No Item Found`)}</h3>
                                <p>
                                  <Trans>
                                    {t(`all-application.No Item Msg`)}
                                  </Trans>
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {isVisible && (
          <div className="filter-shadow filetr-cards">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Filters`)}</h4>
                </div>
                <div className="filter-content cross" onClick={close}>
                  <img src={cross} alt="cross icon" />
                </div>
              </div>
              <div className="bordertops"></div>
              <div className="application-gender">
                <h5>{t(`Bulk Import.Select Applicant Gender`)}</h5>

                <div className="application-button">
                  <div class="cat action">
                    <label>
                      <input
                        type="checkbox"
                        name="Male"
                        onChange={e => handleGenderChange(e)}
                        checked={gender === "Male"}
                      />
                      <span>{t(`Gender.Male`)}</span>
                    </label>
                  </div>
                  <div class="cat action">
                    <label>
                      <input
                        type="checkbox"
                        name="Female"
                        onChange={e => handleGenderChange(e)}
                        checked={gender === "Female"}
                      />
                      <span>{t(`Gender.Female`)} </span>
                    </label>
                  </div>
                  <div class="cat action">
                    <label>
                      <input
                        type="checkbox"
                        name="Other"
                        onChange={e => handleGenderChange(e)}
                        checked={gender === "Other"}
                      />
                      <span>{t(`Gender.Other`)}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="filter-cards-form">
                <form class="form-inline">
                  <div className="col-lg-12">
                    <label>{t("ATS View.Select Job Position")}</label>

                    <div
                      title={
                        selectedRoleOptions.length
                          ? `${selectedRoleOptions
                              .map(option => option.label || option.name)
                              .join(", ")}`
                          : `Please ${t("ATS View.Select Job Position")}`
                      }
                    >
                      <MultiSelect
                        options={roleTypes}
                        value={selectedRoleOptions}
                        onChange={setSelectedRoleOptions}
                        labelledBy="Select Job Position"
                        placeholder="Select"
                        overrideStrings={{
                          selectSomeItems: t("ATS View.Select Job Position"),
                        }}
                      />
                    </div>
                  </div>

                  {/* <div className="col-lg-12">
                  <Form.Select
                    onChange={e => setOnboarding(e.target.value)}
                    aria-label="Default select example"
                    value={onboarding}
                  >
                    <option value="">Select Onboarding Status</option>
                    {OnboardingOptions?.map(el => {
                      return <option value={el?.value}>{el?.label}</option>;
                    })}
                  </Form.Select>
                </div> */}
                  {getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Source Type")}</label>

                      <div
                        title={`${
                          source
                            ? sourceType.find(el => el.value == source)?.label
                            : t("ATS View.Select Source Type")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setSource(e.target.value)}
                          aria-label="Default select example"
                          value={source}
                        >
                          <option value="">
                            {t("ATS View.Select Source Type")}
                          </option>
                          {sourceType?.map(el => {
                            return (
                              <option
                                key={el?.value}
                                value={el?.value}
                                title={el.value}
                              >
                                {el?.label}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
                  )}
                  {getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select State")}</label>

                      <div
                        title={`${
                          state
                            ? states.find(el => el.value == state)?.label
                            : t("ATS View.Select State")
                        }`}
                      >
                        <Form.Select
                          onChange={e => handleStateChange(e)}
                          aria-label="Default select example"
                          value={state}
                        >
                          <option value="">{t("ATS View.Select State")}</option>
                          {states?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
                  )}
                  {getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select City")}</label>

                      <div
                        title={`${
                          city
                            ? filteredCities.find(el => el.value == city)?.label
                            : t("ATS View.Select City")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setCity(e.target.value)}
                          aria-label="Default select example"
                          value={city}
                        >
                          <option value="">{t("ATS View.Select City")}</option>
                          {filteredCities?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
                  )}
                  {/* <div className="col-lg-12">
                    <label>{t('ATS View.Select Area')}</label>
                    <Form.Select
                      onChange={e => setArea(e.target.value)}
                      aria-label="Default select example"
                      value={area}
                    >
                      <option value="">{t('ATS View.Select Area')}</option>
                      {areas?.map(el => {
                        return <option value={el?.value}>{el?.label}</option>;
                      })}
                    </Form.Select>
                  </div> */}

                  {/* Test Status Dropdown */}
                  {getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Test Status")}</label>

                      <div
                        title={`${
                          testStatus
                            ? testtatusOptions.find(
                                el => el.value == testStatus
                              )?.label
                            : t("ATS View.Select Test Status")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setTestStatus(e.target.value)}
                          aria-label="Test Status"
                          value={testStatus}
                        >
                          <option value="">
                            {t("ATS View.Select Test Status")}
                          </option>
                          {testtatusOptions?.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </div>
                  )}
                  {/* Interview Status Dropdown */}
                  {getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Interview Status")}</label>

                      <div
                        title={`${
                          interviewStatusFilter
                            ? interviewStatusOptions.find(
                                el => el.value == interviewStatusFilter
                              )?.label
                            : t("ATS View.Select Interview Status")
                        }`}
                      >
                        <Form.Select
                          onChange={e =>
                            setInterviewStatusFilter(e.target.value)
                          }
                          aria-label="Interview Status"
                          value={interviewStatusFilter} // Directly set to the selected value
                        >
                          <option value="">
                            {t("ATS View.Select Interview Status")}
                          </option>
                          {interviewStatusOptions?.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </div>
                  )}
                  {/* OfferLetter Status Dropdown */}
                  {/* <div className="col-lg-12">
                  <Form.Select
                    onChange={e => setOfferLetterStatus(e.target.value)}
                    aria-label="Offer Status"
                    value={offerLetterStatus} // Directly set to the selected value
                  >
                    <option value="">Select Offer Status</option>
                    {offerLetterOptions?.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </div> */}

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="float-label">
                        {t(`all-application.Custom Date Range`)}
                      </Form.Label>
                      <div className="application-button mb-2">
                        <div className="cat action">
                          <label>
                            <input
                              type="checkbox"
                              name={"Current"}
                              onChange={e => {
                                if (type === "curent") {
                                  setType("");
                                } else {
                                  setType("current");
                                }
                              }}
                              checked={type === "current"}
                            />
                            <span>{t(`all-application.Current`)}</span>
                          </label>
                        </div>
                        <div className="cat action">
                          <label>
                            <input
                              type="checkbox"
                              name={"Last 3 Months"}
                              onChange={e => {
                                if (type === "previous") {
                                  setType("");
                                } else {
                                  setType("previous");
                                }
                              }}
                              checked={type === "previous"}
                            />
                            <span>{t(`all-application.Last 3 Months`)}</span>
                          </label>
                        </div>
                        <div className="cat action">
                          <label>
                            <input
                              type="checkbox"
                              name={"Custom"}
                              onChange={e => {
                                if (type === "custom") {
                                  setType("");
                                } else {
                                  setType("custom");
                                }
                              }}
                              checked={type === "custom"}
                            />
                            <span>{t(`all-application.Custom`)}</span>
                          </label>
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                  {type === "custom" && (
                    <>
                      <Col md={6}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.Start Date`)}
                          </Form.Label>
                          <DatePicker
                            placeholder={t(`all-application.Start Date`)}
                            className="form-control"
                            type={"date"}
                            onChange={e => {
                              setStartDate(e);
                            }}
                            placeholderText={t(`all-application.Start Date`)}
                            id="date"
                            selected={startDate}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3 floating-label">
                          <Form.Label className="float-label">
                            {t(`all-application.End Date`)}
                          </Form.Label>
                          <DatePicker
                            placeholder={t(`all-application.End Date`)}
                            className="form-control"
                            type={"date"}
                            onChange={e => {
                              setEndDate(e);
                            }}
                            placeholderText={t(`all-application.End Date`)}
                            id="date"
                            selected={endDate}
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}
                </form>
                <div className="col-lg-12">
                  <div className="serach-btn">
                    <button
                      className="btn btn-primary reset"
                      onClick={() => clearFilters()}
                    >
                      {t(`ATS View.Reset`)}
                    </button>
                    <button
                      className="btn btn-primary search"
                      onClick={() => handleSubmit()}
                    >
                      {t(`ATS View.Search`)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isReject && (
          <div className="filter-shadow reject-people-data">
            {/* ✅ backdrop FIRST */}
            <div className="black-showd" onClick={reject_close}></div>

            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>
                    {actionType === "reject"
                      ? t("all-application.Reject Application")
                      : t("all-application.Shortlist Application")}
                  </h4>
                </div>
                <div className="filter-content cross" onClick={reject_close}>
                  <img src={cross} alt="" />
                </div>
              </div>

              <div className="reject-people data">
                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={name_icon} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Name")}</p>
                      <h4>{candidateDetails.name}</h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={job} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Job Role")}</p>
                      <h4>{candidateDetails.vacancy?.title}</h4>
                    </div>
                  </div>
                </div>

                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={education} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Education")}</p>
                      <h4>
                        {
                          candidateDetails.master_reference_table
                            ?.highest_qualification
                        }
                      </h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={star_exp} alt="" />
                    </div>
                    <div className="people-name">
                      <p>{t("all-application.Total Exp")}</p>
                      <h4>{candidateDetails.job_user?.total_experience}</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="filter-cards-form reject-data">
                <h4>
                  {actionType === "reject"
                    ? t("all-application.Reject Candidate confirmation")
                    : t("all-application.Shortlist Candidate confirmation")}
                </h4>

                <p>
                  {actionType === "reject"
                    ? t("all-application.Reject Candidate msg")
                    : t("all-application.Shortlist Candidate msg")}
                </p>

                {actionType === "reject" && (
                  <Form.Group className="form-considere mb-2">
                    <Form.Label>Rejected Remark</Form.Label>
                    <Form.Select
                      value={selectedRemark?.id || ""}
                      onChange={handleRemarkChange}
                    >
                      <option value="">Select rejection reason</option>
                      {remarks.map(r => (
                        <option key={r.id} value={r.id}>
                          {r.remark_label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                )}

                <form className="form-inline">
                  <div className="col-lg-12">
                    {/* {actionType !== "reject" && (
                      <Form.Group className="form-considere">
                        <Form.Check
                          type="checkbox"
                          label="Require comment"
                          checked={isCommentRequired}
                          onChange={toggleCommentRequirement}
                        />
                      </Form.Group>
                    )} */}

                    <textarea
                      className="form-control"
                      rows="3"
                      name="comment"
                      value={comment}
                      onChange={e => setComment(e.target.value)}
                      placeholder={
                        actionType === "reject"
                          ? selectedRemark?.is_comment_required
                            ? t("all-application.Reject Comment")
                            : t("all-application.Optional Comment")
                          : t("all-application.Shortlist Comment")
                      }
                    />

                    {commentError && (
                      <div className="text-danger">{commentError}</div>
                    )}
                  </div>

                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <a
                        href="javascript:void(0);"
                        className="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={!isLoading ? handleActionSubmit : undefined}
                        style={
                          isLoading
                            ? { pointerEvents: "none", opacity: 0.6 }
                            : {}
                        }
                      >
                        {isLoading
                          ? t("all-application.Please wait...")
                          : actionType === "reject"
                          ? t("all-application.Reject")
                          : actionType === "shortlist"
                          ? t("all-application.shortlist")
                          : t("all-application.Select")}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {/* Onhold data popup */}
        {isHold && (
          <div className="filter-shadow reject-people-data">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Hold Application`)}</h4>
                </div>
                <div className="filter-content cross" onClick={reject_close}>
                  <img src={cross} alt="cross icons" />
                </div>
              </div>
              <div className="reject-people data">
                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={name_icon} alt="name icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Name`)}</p>
                      <h4>{candidateDetails.name}</h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={job} alt="job icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Job Role`)}</p>
                      <h4>{candidateDetails?.vacancy?.title}</h4>
                    </div>
                  </div>
                </div>

                <div className="data-people">
                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={education} alt="education icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Education`)}</p>
                      <h4>{candidateDetails?.highest_qualification}</h4>
                    </div>
                  </div>

                  <div className="people-biodata">
                    <div className="icon-name">
                      <img src={star_exp} alt="star exp icon" />
                    </div>
                    <div className="people-name">
                      <p>{t(`all-application.Total Exp`)}</p>
                      <h4>{candidateDetails?.job_user?.total_experience}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-cards-form reject-data">
                <h4>{t(`all-application.Hold Candidate confirmation`)}</h4>
                <p>{t(`all-application.Hold Candidate msg`)}</p>
                <form class="form-inline">
                  <div className="col-lg-12">
                    <Form.Group>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(`all-application.Optional Comment`)}
                        rows="3"
                        name="comment"
                        onChange={handleChange}
                      ></textarea>
                      {commentError && (
                        <div className="text-danger">{commentError}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <a
                        href="javascript:void(0);"
                        id="next"
                        class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={() =>
                          handleConfirm(
                            candidateDetails.appl_id,
                            4,
                            comment,
                            "Onhold"
                          )
                        }
                      >
                        {t(`all-application.Hold`)}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="black-showd"></div>
          </div>
        )}
        {isSelected && (
          <div className="filter-shadow reject-people-data">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Select Application`)}</h4>
                </div>
                <div className="filter-content cross" onClick={selected_close}>
                  <img src={cross} alt="cross icon" />
                </div>
              </div>

              <div class="bordertops"></div>
              <div className="reject-people data justify-content-between">
                <div className="mobile-cards">
                  <div className="reject-perople-user">
                    <img
                      src={selectedCandidate?.candidate_photo || user_icons1}
                      alt="user icon"
                      className={
                        selectedCandidate?.candidate_photo
                          ? "image-upload"
                          : "iconuse"
                      }
                    />
                  </div>
                  <div className="header-plant">
                    <h4> {candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="reject-people-user-data">
                  <div className="header-plant ss">
                    <h4> {candidateDetails.name}</h4>
                    {Math.round(feedbackInfo?.averageScore * 10) / 10 > 0 && (
                      <span className="start-icons">
                        <FontAwesomeIcon
                          icon={faStar}
                          style={{ cursor: "pointer", color: "#FEAE44" }}
                        />
                        {Math.round(feedbackInfo?.averageScore * 10) / 10}
                      </span>
                    )}
                  </div>

                  <div className="reject-people-user-data-card">
                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Job Role`)}</p>
                        <h4> {candidateDetails?.vacancy?.title}</h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Education`)}</p>
                        <h4>
                          {candidateDetails?.master_reference_table
                            ?.highest_qualification ||
                            candidateDetails?.highest_qualification}
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Total Exp`)}.</p>
                        <h4>
                          {(candidateDetails?.job_user?.total_experience || 0) +
                            " " +
                            t("Edit Job.years")}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="filter-cards-form reject-data">
                <h4 className="pt-1">
                  {t(`all-application.Select Candidate confirmation`)}
                </h4>
                {/* <p>{t(`all-application.Select Candidate msg`)}</p> */}
                <form class="form-inline pt-2">
                  <div className="col-lg-12">
                    <Form.Group>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        placeholder={t(`all-application.Comment`)}
                        rows="3"
                        onChange={e => setComments(e.target.value)}
                      ></textarea>
                      {commentsError && (
                        <div className="text-danger">{commentsError}</div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-lg-12 pt-3">
                    <Form.Group>
                      <Form.Label>
                        {t(`all-application.Upload Offer`)}
                      </Form.Label>
                      <AvForm>
                        <AvField
                          type="file"
                          className="form-control"
                          id="offer_letter"
                          name="offer_letter"
                          errorMessage="Offer letter is required"
                          placeholder=" "
                          accept=".pdf, .doc, .docx"
                          onChange={e => setOfferLetter(e.target.files[0])}
                          validate={{ required: { value: true } }}
                        />
                      </AvForm>
                    </Form.Group>
                  </div>
                  {/* <p>CTC Offered To Candidate</p> */}
                  <div className="col-lg-12 pt-3">
                    <Form.Group>
                      <Form.Label className="float-label">
                        {t(`all-application.CTC Offered`)}
                      </Form.Label>

                      <Form.Control
                        type="number"
                        placeholder={t(`all-application.Enter CTC Offered`)}
                        name="ctc_offered"
                        onChange={e => setCtcOffered(e.target.value)}
                        validate={{ required: { value: true } }}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <a
                        href="javascript:void(0);"
                        id="next"
                        class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                        onClick={
                          !isLoadingSchedule
                            ? () =>
                                handleSelected(
                                  candidateDetails.appl_id,
                                  candidateDetails.user_id
                                )
                            : undefined
                        }
                        style={
                          isLoadingSchedule
                            ? { pointerEvents: "none", opacity: 0.6 }
                            : {}
                        }
                      >
                        {isLoadingSchedule
                          ? t("all-application.Please wait...")
                          : t(`all-application.Select`)}
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="black-showd"></div>
          </div>
        )}

        <div className="edit-modal">
          {/* New Modal */}
          <Modal
            size="lg"
            show={assessmentModal}
            onHide={() => handleCloseAssessmentModal()}
            className="edit-modal-card asseentModal screeningtest"
          >
            <Modal.Body>
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`ATS View.Assessment Center`)}</h4>
                </div>
                <div
                  className="filter-content cross"
                  onClick={handleCloseAssessmentModal}
                >
                  <img src={cross} alt="cross icons" />
                </div>
              </div>
              <div className="bordertops"></div>

              <div className="row mb-3 invite-for-interview">
                <div className="reject-people data justify-content-between">
                  <div className="mobile-cards">
                    <div className="reject-perople-user">
                      <img
                        src={selectedCandidate?.candidate_photo || user_icons1}
                        alt="user icon"
                        className={
                          selectedCandidate?.candidate_photo
                            ? "image-upload"
                            : "iconuse"
                        }
                      />
                    </div>
                    <div className="header-plant">
                      <h4
                        onClick={() => {
                          history.push(
                            `/candidate_consolidate/view-details/${selectedCandidate.appl_id}`
                          );
                        }}
                      >
                        {" "}
                        {selectedCandidate?.name}
                      </h4>
                      {Math.round(feedbackInfo?.averageScore * 10) / 10 > 0 && (
                        <span className="start-icons">
                          <FontAwesomeIcon
                            icon={faStar}
                            style={{ cursor: "pointer", color: "#FEAE44" }}
                          />
                          {Math.round(feedbackInfo?.averageScore * 10) / 10}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="reject-people-user-data">
                    <div className="header-plant ss">
                      <h4
                        onClick={() => {
                          history.push(
                            `/candidate_consolidate/view-details/${selectedCandidate.appl_id}`
                          );
                        }}
                      >
                        {selectedCandidate?.name?.toLowerCase()}
                      </h4>
                      {Math.round(feedbackInfo?.averageScore * 10) / 10 > 0 && (
                        <span className="start-icons">
                          <FontAwesomeIcon
                            icon={faStar}
                            style={{ cursor: "pointer", color: "#FEAE44" }}
                          />
                          {Math.round(feedbackInfo?.averageScore * 10) / 10}
                          {/* 4.5 */}
                        </span>
                      )}
                    </div>

                    <div className="reject-people-user-data-card">
                      {/* <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`ATS View.Candidate Name`)}</p>
                          <h4
                            className="clickable-link"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              history.push(
                                `/candidate_consolidate/view-details/${selectedCandidate.appl_id}`
                              );
                            }}
                          >
                            {selectedCandidate?.name}
                          </h4>
                        </div>
                      </div> */}

                      <div className="people-biodata pb-0">
                        {/* <div className="icon-name">
                          <img src={job} alt="" />
                        </div> */}
                        <div className="people-name">
                          <p>{t(`ATS View.Job Role`)}</p>
                          <h4>{selectedCandidate?.roleType}</h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`ATS View.Highest education`)}</p>
                          <h4>
                            {
                              selectedCandidate?.allInfo?.master_reference_table
                                ?.highest_qualification
                            }
                          </h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`View Details.Total Experience`)}</p>
                          <h4>
                            {selectedCandidate?.allInfo?.job_user
                              ?.total_experience != null
                              ? `${
                                  selectedCandidate.allInfo.job_user
                                    .total_experience
                                }${t(`View Details.Years`)}`
                              : "-"}
                          </h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`ATS View.Applied on`)}</p>
                          <h4> {selectedCandidate?.createdAt}</h4>
                        </div>
                      </div>

                      {selectedCandidate?.allInfo?.job_user?.resume && (
                        <div className="people-biodata resume-last pb-0">
                          <div className="people-name">
                            <p>{t(`View Details.Resume`)}</p>
                            <h4
                              onClick={() =>
                                window.open(
                                  `${selectedCandidate?.allInfo?.job_user?.resume}`,
                                  "_blank"
                                )
                              }
                            >
                              <span className="filter-content cross">
                                {t(`View Details.View Resume`)}
                              </span>
                            </h4>
                          </div>
                        </div>
                      )}

                      <a
                        className="feedback_interview"
                        onClick={() => {
                          setAssessmentModal(false);
                          handleNotes();
                        }}
                      >
                        <img src={addnotoes} alt="write feedback" />
                        View Notes
                      </a>

                      {/* <div className="form-group">
                      <label>
                        <strong>Candidate Name:</strong>{" "}
                        {selectedCandidate?.name}
                      </label>
                    </div>
                    <div className="form-group">
                      <label className="w-100 text-end">
                        <strong>Role Type:</strong>{" "}
                        {selectedCandidate?.roleType}
                      </label>
                    </div> */}
                    </div>
                  </div>
                </div>

                {roundListData?.length > 0 &&
                  (loading ? (
                    <Spinner size="sm" />
                  ) : (
                    <div className="mt-2 aaessment-card-center">
                      <div className="accrodion-cards-panel">
                        <RoundList
                          roundListData={roundListData}
                          handleTabClick={handleTabClick}
                          feedbackInfo={feedbackInfo}
                          allNotes={allNotes}
                          handleRemoveNote={handleRemoveNote}
                          toggleReadMore={toggleReadMore}
                          toggleAccordion={toggleAccordion}
                          handleInterviewModal={handleInterviewModal}
                          handleScreenTest={handleScreenTest}
                          setRoundStatus={setRoundStatus}
                          handleUpdateRoundStatus={handleUpdateRoundStatus}
                          getAssesmentLink={getAssesmentLink}
                          handleCopyLink={handleCopyLink}
                          setActiveTab={setActiveTab}
                          activeTab={activeTab}
                          activeIndex={activeIndex}
                          setActiveIndex={setActiveIndex}
                          t={t}
                          roundStatus={roundStatus}
                          readMoreStates={readMoreStates}
                          selectedCandidate={selectedCandidate}
                          open_slider={open_slider}
                          handleShow={handleShow}
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            size="xl"
            show={isFormVisible}
            onHide={() => handleToggleForm()}
            className="edit-modal-card asseentModal reschedule-calender"
          >
            <Modal.Body>
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>
                    {" "}
                    {interviewType === "schedule"
                      ? t(`ATS View.Schedule`)
                      : t(`ATS View.Reschedule`)}{" "}
                    {t(`ATS View.Interview`)}
                  </h4>
                </div>
                <div
                  className="filter-content cross"
                  onClick={handleToggleForm}
                >
                  <img src={cross} alt="cross icon" />
                </div>
              </div>
              <div className="bordertops"></div>
              <Form
                onSubmit={e => {
                  if (interviewType === "schedule") {
                    handleInterviewSubmit(e);
                  } else {
                    handleRescheduleSubmit(e);
                  }
                }}
                className="mt-2"
              >
                <div className="form-group screenest">
                  <div className="row">
                    {/* // Button for Add TimeSlots */}
                    <div className="modal-action-btn text-left mt-2">
                      <button
                        type="submit"
                        disabled={isTimeslotBtnDisabled}
                        className="btn btn-primary mb-2"
                        id="book_schedule"
                        onClick={handleAddTimeslotsClick} // Trigger showing TimeslotBookingAdmin
                      >
                        {t(`ATS View.Add TimeSlots`)}
                      </button>
                    </div>

                    {/* // Conditionally render TimeslotBookingAdmin when showTimeslotBooking is true */}
                    {showTimeslotBooking && (
                      <div>
                        <TimeslotBookingAdmin
                          onValueChange={handleChildValueChange || {}}
                          onErrorHandle={handleErrorsValueChange || {}}
                          defaultTimeSlots={timeSlotsData || {}}
                        />
                        <Form.Group className="cta text-center gap-3 d-flex justify-content-left mt-4 mb-4">
                          <button
                            style={{ marginLeft: "5px" }}
                            className="btn btn-secondary"
                            onClick={handleCancelClick} // Hide TimeslotBookingAdmin on click
                          >
                            {t(`ATS View.Cancel`)}
                          </button>
                          <ButtonLoader
                            title={t(`ATS View.Save Details`)}
                            variant="primary"
                            style={{ marginLeft: "5px" }}
                            type="submit"
                            loading={isLoading}
                            message={"Saving"}
                            onClick={e => {
                              handleTimeslotSubmit(e);
                            }}
                          />
                        </Form.Group>
                      </div>
                    )}

                    <div
                      id="interview-group"
                      className="form-group form-group-lg col-sm-6 formvisible mt-3"
                    >
                      <label>{t(`ATS View.Enter Interview Title`)}:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changeHandlers}
                        name="interview_title"
                        id="interview_title"
                        placeholder={t(`ATS View.Enter Interview Title`)}
                        value={formData?.interview_title}
                        disabled
                      />
                      {errors?.interview_title && (
                        <p className="text-danger">{errors?.interview_title}</p>
                      )}
                    </div>
                    <div
                      id="interviewer-group"
                      className="form-group form-group-lg col-sm-6 formvisible mt-3"
                    >
                      <label>{t(`all-application.Select Interviewer`)}:</label>

                      <select
                        id="interviewere_time"
                        onChange={changeHandlers}
                        name="interviewer_time"
                        className="form-select form-control"
                        data-width="100%"
                        data-size="10"
                        title={t(`all-application.Select Interviewer`)}
                        value={formData?.interviewer_time || "0"}
                        disabled={isAssignedInterviewer}
                      >
                        <option value="0">
                          {t(`all-application.Select Interviewer`)}
                        </option>

                        {interViewers?.map(el => (
                          <option key={el?.id} value={String(el?.value)}>
                            {el?.label}
                          </option>
                        ))}
                      </select>

                      {errors?.interviewer_time && (
                        <p className="text-danger">
                          {errors?.interviewer_time}
                        </p>
                      )}
                    </div>
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible date-calender"
                    >
                      <label>{t(`ATS View.Start Date & Time`)}:</label>
                      <DatePicker
                        id="int_start_time"
                        name="int_start_time"
                        selected={
                          int_start_time ? new Date(int_start_time) : ""
                        }
                        // onChange={value => {
                        //   if (value >= new Date()) {
                        //     handleStartDateChange(value);
                        //     setErrors({ ...errors, int_start_time: "" });
                        //   } else {
                        //     setErrors({
                        //       ...errors,
                        //       int_start_time: "Cannot Select Past Dates.",
                        //     });
                        //   }
                        // }}
                        onChange={value => handleStartDateChange(value)}
                        selectsStart
                        startDate={
                          int_start_time ? new Date(int_start_time) : ""
                        }
                        endDate={int_end_time ? new Date(int_end_time) : ""}
                        minDate={new Date()}
                        placeholderText={t(`ATS View.dd-mm-yyyy`)}
                        dateFormat="dd-MMM-yyyy"
                        required={true}
                        className={`form-control`}
                        onKeyDown={e => e.preventDefault()}
                        autoComplete="off"
                        // Remove the time-related props
                        // showTimeSelect
                        // timeFormat="HH:mm"
                        // timeIntervals={30}
                        // includeTimes={availableTimes.map(slot => {
                        //   const [startHour, startMinute] = slot.startTime.split(":");
                        //   const today = new Date();
                        //   const selectedTime = new Date(today.setHours(startHour, startMinute));
                        //   return selectedTime;
                        // })}
                        // timeCaption="Time"
                      />
                      <Form.Control
                        as="select"
                        value={selectedStartTime}
                        onChange={e => handleStartTimeChange(e.target.value)}
                        className="form-control mt-2 time-slots"
                      >
                        <option value="">
                          {t(`ATS View.Select Start Time`)}
                        </option>
                        {sDateTimeSlots?.map((time, index) => (
                          <option key={index} value={time}>
                            {time}
                          </option>
                        ))}
                      </Form.Control>

                      {errors?.selectedStartTime && (
                        <p className="text-danger">
                          {errors?.selectedStartTime}
                        </p>
                      )}
                      <small>{t(`ATS View.Note`)}</small>
                      {errors?.int_start_time && (
                        <p className="text-danger">{errors?.int_start_time}</p>
                      )}
                    </div>
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible date-calender"
                    >
                      <label>{t(`ATS View.End Date & Time`)}:</label>
                      <DatePicker
                        id="int_end_time"
                        name="int_end_time"
                        selected={int_end_time ? new Date(int_end_time) : ""}
                        // onChange={value => {
                        //   if (value >= new Date()) {
                        //     handleEndDateChange(value);
                        //     setErrors({ ...errors, int_end_time: "" });
                        //   } else {
                        //     setErrors({
                        //       ...errors,
                        //       int_end_time: "Cannot Select Past Dates.",
                        //     });
                        //   }
                        // }}
                        onChange={value => handleEndDateChange(value)}
                        selectsEnd
                        startDate={
                          int_start_time ? new Date(int_start_time) : ""
                        }
                        endDate={int_end_time ? new Date(int_end_time) : ""}
                        minDate={
                          int_start_time ? new Date(int_start_time) : new Date()
                        }
                        minimumDate={
                          int_start_time ? int_start_time : utils().getToday()
                        }
                        showFullMonthYearPicker
                        // showTimeSelect
                        placeholderText={t(`ATS View.dd-mm-yyyy`)}
                        // timeFormat="h:mm aa"
                        required={true}
                        // timeIntervals={15}
                        shouldHighlightWeekends
                        calendarPopperPosition="bottom"
                        autoComplete="off"
                        dateFormat="dd-MMM-yyyy"
                        // timeCaption="Time"
                        className={`form-control`}
                        onKeyDown={e => e.preventDefault()}
                      />
                      <Form.Control
                        as="select"
                        value={selectedEndTime}
                        onChange={handleEndTimeChange}
                        className="form-control mt-2"
                      >
                        <option value="">
                          {t(`ATS View.Select End Time`)}
                        </option>
                        {eDateTimeSlots?.map((time, index) => (
                          <option key={index} value={time}>
                            {time}
                          </option>
                        ))}
                      </Form.Control>

                      {errors?.selectedEndTime && (
                        <p className="text-danger">{errors?.selectedEndTime}</p>
                      )}
                      {errors?.int_end_time && (
                        <p className="text-danger">{errors?.int_end_time}</p>
                      )}
                    </div>

                    <Row className="mt-3">
                      <Col md={6}>
                        <div
                          id="interviewer-group"
                          className="form-group form-group-lg formvisible"
                        >
                          <label>{t(`ATS View.Select Interview Type`)}:</label>
                          <select
                            id="interviewType"
                            onChange={e => {
                              setFormData(prevFormData => ({
                                ...prevFormData,
                                meeting_type: parseInt(e.target.value),
                              }));
                            }}
                            name="interviewType"
                            className="form-select form-control"
                            data-width="100%"
                            data-size="10"
                            title={t(`ATS View.Select Interview Type`)}
                            value={formData?.meeting_type}
                          >
                            <option value={0}>{t(`ATS View.Offline`)}</option>
                            <option value={1}>{t(`ATS View.Online`)}</option>
                          </select>
                        </div>
                      </Col>
                      {formData?.meeting_type === 1 && teamsIntegrated && (
                        <Col md={6}>
                          <label> {t(`ATS View.Schedule on Teams`)}:</label>{" "}
                          <br />
                          <div className="">
                            <label
                              className="switch mt-3"
                              htmlFor={"tableSwitch"}
                            >
                              <input
                                type="checkbox"
                                id={`tableSwitch`}
                                onClick={e => {
                                  setFormData(prevFormData => ({
                                    ...prevFormData,
                                    teams_interview: e.target.checked,
                                  }));
                                }}
                                checked={formData?.teams_interview}
                              />
                              <div className="slider round"></div>
                            </label>
                          </div>
                        </Col>
                      )}

                      <div
                        id="address-group"
                        className="form-group form-group-lg col-sm-6 formvisible"
                      >
                        {formData?.meeting_type === 0 && (
                          <>
                            <label>
                              {" "}
                              {t(`ATS View.Enter Offline Address`)}:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={changeHandlers}
                              name="address"
                              id="address"
                              placeholder={t(`ATS View.Enter Address`)}
                              value={formData?.address}
                            />
                            {errors?.address && (
                              <p className="text-danger">{errors?.address}</p>
                            )}
                          </>
                        )}
                        {formData?.meeting_type === 1 &&
                          !formData?.teams_interview && (
                            <>
                              <label> {t(`ATS View.Meeting Link`)}:</label>{" "}
                              <br />
                              <input
                                type="text"
                                className="form-control"
                                onChange={changeHandlers}
                                name="address"
                                id="address"
                                placeholder={t(`ATS View.Enter Meeting Link`)}
                                value={formData?.address}
                              />
                              {errors?.address && (
                                <p className="text-danger">{errors?.address}</p>
                              )}
                            </>
                          )}
                      </div>
                      <div
                        id="req_documents-group"
                        className="form-group form-group-lg col-sm-12 formvisible mt-3"
                      >
                        <label>
                          {t(`ATS View.Required Documents (If Any)`)}
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          onChange={changeHandlers}
                          name="req_documents"
                          id="req_documents"
                          placeholder={t(`ATS View.Mention Documents Needed`)}
                          value={formData?.req_documents}
                        ></textarea>
                        {errors?.req_documents && (
                          <p className="text-danger">{errors?.req_documents}</p>
                        )}
                      </div>
                    </Row>
                  </div>
                </div>
                <div className="modal-action-btn text-left  mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary mb-2"
                    id="book_schedule"
                  >
                    {t(`ATS View.Submit`)}
                  </button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
          {/* new model closed */}
        </div>

        <div className="edit-modal">
          <Modal
            size="xl"
            show={isFormVisible}
            onHide={() => handleToggleForm()}
            className="edit-modal-card asseentModal reschedule-calender"
          >
            <Modal.Body>
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>
                    {" "}
                    {interviewType === "schedule"
                      ? t(`all-application.Schedule`)
                      : t(`all-application.Reschedule`)}{" "}
                    {t(`all-application.Interview`)}
                  </h4>
                </div>
                <div
                  className="filter-content cross"
                  onClick={handleToggleForm}
                >
                  <img src={cross} alt="cross icon" />
                </div>
              </div>
              <div className="bordertops"></div>
              <Form
                onSubmit={e => {
                  if (interviewType === "schedule") {
                    handleInterviewSubmit(e);
                  } else {
                    handleRescheduleSubmit(e);
                  }
                }}
                className="mt-2"
              >
                <div className="form-group screenest">
                  <div className="row">
                    {/* // Button for Add TimeSlots */}
                    <div className="modal-action-btn text-left mt-2">
                      <button
                        type="submit"
                        disabled={isTimeslotBtnDisabled}
                        className="btn btn-primary mb-1"
                        id="book_schedule"
                        onClick={handleAddTimeslotsClick} // Trigger showing TimeslotBookingAdmin
                      >
                        {t(`all-application.Add Timeslots`)}
                      </button>
                    </div>

                    {/* // Conditionally render TimeslotBookingAdmin when showTimeslotBooking is true */}
                    {showTimeslotBooking && (
                      <div>
                        <TimeslotBookingAdmin
                          onValueChange={handleChildValueChange || {}}
                          onErrorHandle={handleErrorsValueChange || {}}
                          defaultTimeSlots={timeSlotsData || {}}
                        />
                        <Form.Group className="cta text-center gap-3 d-flex justify-content-left mt-4 mb-4">
                          <button
                            style={{ marginLeft: "5px" }}
                            className="btn btn-secondary"
                            onClick={handleCancelClick} // Hide TimeslotBookingAdmin on click
                          >
                            {t(`all-application.Cancel`)}
                          </button>
                          <ButtonLoader
                            title="Save Details"
                            variant="primary"
                            style={{ marginLeft: "5px" }}
                            type="submit"
                            loading={isLoading}
                            message={"Saving"}
                            onClick={e => {
                              handleTimeslotSubmit(e);
                            }}
                          />
                        </Form.Group>
                      </div>
                    )}

                    <div
                      id="interview-group"
                      className="form-group form-group-lg col-sm-6 formvisible mt-3"
                    >
                      <label>
                        {t(`all-application.Enter Interview Title`)}:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changeHandlers}
                        name="interview_title"
                        id="interview_title"
                        placeholder={t(`all-application.Enter Interview Title`)}
                        value={formData?.interview_title}
                        disabled
                      />
                      {errors?.interview_title && (
                        <p className="text-danger">{errors?.interview_title}</p>
                      )}
                    </div>
                    <div
                      id="interviewer-group"
                      className="form-group form-group-lg col-sm-6 formvisible mt-3"
                    >
                      <label>{t(`all-application.Select Interviewer`)}:</label>

                      <select
                        id="interviewere_time"
                        onChange={changeHandlers}
                        name="interviewer_time"
                        className="form-select form-control"
                        data-width="100%"
                        data-size="10"
                        title={t(`all-application.Select Interviewer`)}
                        value={formData?.interviewer_time || "0"}
                        disabled={isAssignedInterviewer}
                      >
                        <option value="0">
                          {t(`all-application.Select Interviewer`)}
                        </option>

                        {interViewers?.map(el => (
                          <option key={el?.id} value={String(el?.value)}>
                            {el?.label}
                          </option>
                        ))}
                      </select>

                      {errors?.interviewer_time && (
                        <p className="text-danger">
                          {errors?.interviewer_time}
                        </p>
                      )}
                    </div>
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible date-calender mt-3"
                    >
                      <label>{t(`all-application.Select Start Time`)}:</label>

                      <div className="d-flex application-card-time">
                        <DatePicker
                          id="int_start_time"
                          name="int_start_time"
                          selected={
                            int_start_time ? new Date(int_start_time) : ""
                          }
                          onChange={value => handleStartDateChange(value)}
                          selectsStart
                          startDate={
                            int_start_time ? new Date(int_start_time) : ""
                          }
                          endDate={int_end_time ? new Date(int_end_time) : ""}
                          minDate={new Date()}
                          placeholderText="dd-mm-yyyy"
                          dateFormat="dd-MMM-yyyy"
                          required={true}
                          className={`form-control`}
                          onKeyDown={e => e.preventDefault()}
                          autoComplete="off"
                        />

                        <Form.Control
                          as="select"
                          value={selectedStartTime}
                          onChange={e => handleStartTimeChange(e.target.value)}
                          className="form-control"
                        >
                          <option value="">
                            {t(`all-application.Select Start Time`)}
                          </option>
                          {sDateTimeSlots?.map((time, index) => (
                            <option key={index} value={time}>
                              {time}
                            </option>
                          ))}
                        </Form.Control>
                      </div>

                      {errors?.selectedStartTime && (
                        <p className="text-danger">
                          {errors?.selectedStartTime}
                        </p>
                      )}
                      <small>{t(`all-application.Max Duration`)}</small>
                      {errors?.int_start_time && (
                        <p className="text-danger">{errors?.int_start_time}</p>
                      )}
                    </div>
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible date-calender mt-3"
                    >
                      <label>{t(`all-application.End Date & Time`)}:</label>

                      <div className="d-flex application-card-time">
                        <DatePicker
                          id="int_end_time"
                          name="int_end_time"
                          selected={int_end_time ? new Date(int_end_time) : ""}
                          // onChange={value => {
                          //   if (value >= new Date()) {
                          //     handleEndDateChange(value);
                          //     setErrors({ ...errors, int_end_time: "" });
                          //   } else {
                          //     setErrors({
                          //       ...errors,
                          //       int_end_time: "Cannot Select Past Dates.",
                          //     });
                          //   }
                          // }}
                          onChange={value => handleEndDateChange(value)}
                          selectsEnd
                          startDate={
                            int_start_time ? new Date(int_start_time) : ""
                          }
                          endDate={int_end_time ? new Date(int_end_time) : ""}
                          minDate={
                            int_start_time
                              ? new Date(int_start_time)
                              : new Date()
                          }
                          minimumDate={
                            int_start_time ? int_start_time : utils().getToday()
                          }
                          showFullMonthYearPicker
                          // showTimeSelect
                          placeholderText="dd-mm-yyyy"
                          // timeFormat="h:mm aa"
                          required={true}
                          // timeIntervals={15}
                          shouldHighlightWeekends
                          calendarPopperPosition="bottom"
                          autoComplete="off"
                          dateFormat="dd-MMM-yyyy"
                          // timeCaption="Time"
                          className={`form-control`}
                          onKeyDown={e => e.preventDefault()}
                        />
                        <Form.Control
                          as="select"
                          value={selectedEndTime}
                          onChange={handleEndTimeChange}
                          className="form-control"
                        >
                          <option value="">
                            {t(`all-application.End Date & Time`)}
                          </option>
                          {eDateTimeSlots?.map((time, index) => (
                            <option key={index} value={time}>
                              {time}
                            </option>
                          ))}
                        </Form.Control>
                      </div>

                      {errors?.selectedEndTime && (
                        <p className="text-danger">{errors?.selectedEndTime}</p>
                      )}
                      {errors?.int_end_time && (
                        <p className="text-danger">{errors?.int_end_time}</p>
                      )}
                    </div>

                    <Col md={6}>
                      <div
                        id="interviewer-group"
                        className="form-group form-group-lg formvisible mt-3"
                      >
                        <label>
                          {t(`all-application.Select Interview Type`)}:
                        </label>
                        <select
                          id="interviewType"
                          onChange={e => {
                            setFormData(prevFormData => ({
                              ...prevFormData,
                              meeting_type: parseInt(e.target.value),
                            }));
                          }}
                          name="interviewType"
                          className="form-select form-control"
                          data-width="100%"
                          data-size="10"
                          title={t(`all-application.Select Interview Type`)}
                          value={formData?.meeting_type}
                        >
                          <option
                            value={0}
                            selected={0 == formData?.meeting_type}
                          >
                            {t(`all-application.Offline`)}
                          </option>
                          <option
                            value={1}
                            selected={1 == formData?.meeting_type}
                          >
                            {t(`all-application.Online`)}
                          </option>
                        </select>
                      </div>
                    </Col>
                    {formData?.meeting_type === 1 && teamsIntegrated && (
                      <Col md={6} className="mt-3">
                        <label>{t(`all-application.Schedule on Teams`)}:</label>{" "}
                        <br />
                        <div className="">
                          <label
                            className="switch mt-3"
                            htmlFor={"tableSwitch"}
                          >
                            <input
                              type="checkbox"
                              id={`tableSwitch`}
                              onClick={e => {
                                setFormData(prevFormData => ({
                                  ...prevFormData,
                                  teams_interview: e.target.checked,
                                }));
                              }}
                              checked={formData?.teams_interview}
                            />
                            <div className="slider round"></div>
                          </label>
                        </div>
                      </Col>
                    )}

                    <div
                      id="address-group"
                      className="form-group form-group-lg col-sm-6 formvisible mt-3"
                    >
                      {formData?.meeting_type === 0 && (
                        <>
                          <label>{t(`ATS View.Enter Offline Address`)}:</label>
                          <input
                            type="text"
                            className="form-control"
                            onChange={changeHandlers}
                            name="address"
                            id="address"
                            placeholder={t(`all-application.Enter Address`)}
                            value={formData?.address}
                          />
                          {errors?.address && (
                            <p className="text-danger">{errors?.address}</p>
                          )}
                        </>
                      )}
                      {formData?.meeting_type === 1 &&
                        !formData?.teams_interview && (
                          <>
                            <label>{t(`all-application.Meeting Link`)}:</label>{" "}
                            <br />
                            <input
                              type="text"
                              className="form-control"
                              onChange={changeHandlers}
                              name="address"
                              id="address"
                              placeholder={t(
                                `all-application.Enter Meeting Link`
                              )}
                              value={formData?.address}
                            />
                            {errors?.address && (
                              <p className="text-danger">{errors?.address}</p>
                            )}
                          </>
                        )}
                    </div>
                    <div
                      id="req_documents-group"
                      className="form-group form-group-lg col-sm-12 formvisible mt-3"
                    >
                      <label>{t(`all-application.Required Docs`)}</label>
                      <textarea
                        type="text"
                        className="form-control"
                        onChange={changeHandlers}
                        name="req_documents"
                        id="req_documents"
                        placeholder={t(
                          `all-application.Mention Documents Needed`
                        )}
                        value={formData?.req_documents}
                      ></textarea>
                      {errors?.req_documents && (
                        <p className="text-danger">{errors?.req_documents}</p>
                      )}
                    </div>
                  </div>

                  <div className="modal-action-btn text-left  mt-4  d-flex align-items-center gap-3">
                    <button
                      type="reset"
                      class="btn btn-primary reset"
                      onClick={() => {
                        clearDtTime();
                        setFormData(initialFormData);
                      }}
                      onHide={() => handleToggleForm()}
                    >
                      Reset
                    </button>
                    <ButtonLoader
                      title={t(`all-application.Submit`)}
                      variant="primary"
                      style={{ marginLeft: "5px" }}
                      type="submit"
                      loading={isLoadingSchedule}
                      message={"Saving"}
                      id="book_schedule"
                    />
                  </div>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </div>

        <div className="edit-modal">
          <Modal
            size="lg"
            show={isForm3Visible}
            onHide={() => handleToggleFeeddback()}
            className="edit-modal-card "
          >
            {/* <Modal.Header closeButton>
              <Modal.Title>Submit Feedback</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Submit Feedback`)}</h4>
                </div>
                <div
                  className="filter-content cross"
                  onClick={handleToggleFeeddback}
                >
                  <img src={cross} alt="cross icon" />
                </div>
              </div>
              <Form onSubmit={handlefeedbackSubmit} className="pt-4">
                <div className="form-group">
                  <div className="row">
                    <div
                      id="address-group"
                      className="form-group form-group-lg col-sm-12"
                    >
                      <label>{t(`all-application.Enter Comment`)}:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changecomment}
                        name="comment"
                        id="comment"
                        placeholder={t(`all-application.Enter Comment`)}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-action-btn text-left mt-2">
                  <button type="submit" className="btn btn-primary">
                    {t(`all-application.Submit`)}
                  </button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </div>

        {isFeedback && (
          <div className="filter-shadow reject-people-data">
            <div className="filters-cards">
              <div className="filters-cards-cross">
                <div className="filter-content">
                  <h4>{t(`all-application.Application Feedback`)}</h4>
                </div>
                <div className="filter-content cross" onClick={feedback_close}>
                  <img src={cross} alt="cross icon" />
                </div>
              </div>
              <div className="bordertops"></div>

              <div className="reject-people data justify-content-between">
                <div className="mobile-cards">
                  <div className="reject-perople-user">
                    <img
                      src={selectedCandidate?.candidate_photo || user_icons1}
                      alt="user icon"
                      className={
                        selectedCandidate?.candidate_photo
                          ? "image-upload"
                          : "iconuse"
                      }
                    />
                  </div>
                  <div className="header-plant">
                    <h4> {selectedCandidate?.name}</h4>
                    <span className="start-icons">
                      <FontAwesomeIcon
                        icon={faStar}
                        style={{ cursor: "pointer", color: "#FEAE44" }}
                      />
                      {Math.round(feedbackInfo?.averageScore * 10) / 10}
                    </span>
                  </div>
                </div>

                <div className="reject-people-user-data">
                  <div className="header-plant ss">
                    <h4> {candidateDetails.name}</h4>
                    {Math.round(feedbackInfo?.averageScore * 10) / 10 > 0 && (
                      <span className="start-icons">
                        <FontAwesomeIcon
                          icon={faStar}
                          style={{ cursor: "pointer", color: "#FEAE44" }}
                        />
                        {Math.round(feedbackInfo?.averageScore * 10) / 10}
                      </span>
                    )}
                  </div>

                  <div className="reject-people-user-data-card">
                    <div className="people-biodata pb-0">
                      <div className="people-name">
                        <p>{t(`all-application.Job Role`)}</p>
                        <h4> {candidateDetails.vacancy?.title}</h4>
                      </div>
                    </div>
                    <div className="reject-people-user-data-card">
                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`all-application.Job Role`)}</p>
                          <h4>
                            {" "}
                            {
                              candidateDetails.vacancy?.franchise
                                ?.franchise_name
                            }
                          </h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`all-application.Education`)}</p>
                          <h4>
                            {
                              selectedCandidate?.allInfo?.master_reference_table
                                ?.highest_qualification
                            }
                          </h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`all-application.Total Exp`)}</p>
                          <h4>
                            {selectedCandidate?.allInfo?.job_user
                              ?.total_experience + t(`View Details.Years`)}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filter-cards-form reject-data">
                  <form class="form-inline">
                    <div className="col-lg-12">
                      <label> {t(`all-application.Add Rating`)}</label>
                      {categories.map((category, index) => (
                        <div key={index} className="category-rating d-flex ">
                          <h5 className="">{category.name}</h5>
                          <RatingStars
                            totalStars={category.totalStars}
                            onChange={rating =>
                              handleChangeRating(category.name, rating)
                            }
                          />
                        </div>
                      ))}
                    </div>

                    <div className="col-lg-12 pt-3">
                      <label> {t(`all-application.Add Comment`)}</label>
                      <Form.Group>
                        <textarea
                          class="form-control"
                          id="exampleFormControlTextarea1"
                          placeholder={t(`ATS View.Comment is compulsory`)}
                          rows="3"
                          name="comment"
                          onChange={handleChange}
                        ></textarea>
                        {commentError && (
                          <div className="text-danger">{commentError}</div>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-lg-12">
                      <div className="serach-btn">
                        <a
                          href="javascript:void(0);"
                          id="next"
                          class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                          onClick={() =>
                            handlefeedback(candidateDetails.appl_id, 8, comment)
                          }
                        >
                          {t(`all-application.Submit`)}
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="black-showd"></div>
            </div>
          </div>
        )}

        {/* <button className="btn btn-primary" onClick={handleShow}>
          Open Modal
        </button> */}

        {showModal && (
          <>
            <div className="chatbox-notes-popup">
              <div className="name-candidate">
                <h4>{t(`View Details.Key Remarks on Candidate`)}</h4>
                <div
                  className="crossbtn"
                  onClick={handleClose}
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                >
                  <img src={cross} alt="cross" />
                </div>
              </div>
              <div className="bordertops"></div>
              <div className="chatbox-search-box">
                <Form>
                  <Form.Group
                    className="w-100"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>
                      {t(`View Details.Write Your Notes Here`)}
                    </Form.Label>
                    <textarea
                      className="form-control"
                      placeholder={t(`View Details.Add Notes`)}
                    />
                    <p>
                      {t(
                        `View Details.300 characters remaining to reach the max limit`
                      )}
                    </p>
                  </Form.Group>

                  <Form.Group className="cta text-center gap-3 d-flex justify-content-left mt-4 mb-4">
                    <button
                      className="btn btn-secondary"
                      // onClick={handleClose}
                    >
                      {t(`View Details.Cancel`)}
                    </button>
                    <button
                      className="serach btn btn-primary"
                      onClick={() => handleAddNote()}
                    >
                      {t(`View Details.Save`)}
                    </button>
                  </Form.Group>
                </Form>
              </div>
            </div>
            <div className="backcover-modal"></div>
          </>
        )}

        {showNotes && (
          <>
            <div className="edit-modal">
              <Modal
                show={showNotes}
                onHide={handleCloseModal}
                className="edit-modal-card interview_Notes"
              >
                {/* <Modal.Header closeButton></Modal.Header> */}
                <Modal.Body>
                  <div className="filters-cards-cross">
                    <div className="filter-content">
                      <h4>Interview Notes</h4>
                    </div>
                    <div
                      className="filter-content cross"
                      onClick={() => {
                        handleCloseModal();
                        setAssessmentModal(true);
                      }}
                    >
                      <img src={cross} alt="cross icon" />
                    </div>
                  </div>
                  <div className="bordertops"></div>
                  <div className="interview-notes-cards">
                    <div className="row">
                      {allNotes?.length > 0 &&
                        allNotes?.map(el => {
                          return (
                            <Col lg={12} className="mb-2">
                              <div className="chat-nots-card">
                                <div className="chat-header">
                                  <div>
                                    <h6>{el?.user?.name || ""} </h6>
                                    <p>({el?.user?.email || ""}) </p>
                                  </div>
                                  <div
                                    className="delete-icon cursor-pointer"
                                    title={t(`View Details.Remove Note`)}
                                    onClick={() => handleRemoveNote(el)}
                                  >
                                    <span>
                                      <img
                                        src={delete_icon}
                                        alt="delete icon"
                                      />
                                    </span>
                                  </div>
                                </div>
                                <div className="chat-comment">
                                  <p>
                                    {readMoreStates[el.id]
                                      ? el?.note
                                      : `${el?.note.substring(0, 250)}`}

                                    {el?.note.length > 250 && (
                                      <button
                                        onClick={() => toggleReadMore(el.id)}
                                        className="btn btn-link"
                                      >
                                        {readMoreStates[el.id]
                                          ? t(`View Details.Read Less`)
                                          : t(`View Details.Read More`)}
                                      </button>
                                    )}
                                  </p>
                                </div>

                                <div className="chat-footer">
                                  <div className="chat-calender">
                                    {/* <span>
                                    <img src={calednder} alt="" />
                                  </span> */}
                                    <p>
                                      {el?.createdAt
                                        ? moment(
                                            getCompanyTimezoneDateTime(
                                              el?.createdAt
                                            )
                                          ).format("Do MMM'YY | hh:mm a")
                                        : ""}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                      {allNotes?.length === 0 && (
                        <>
                          <div className="no-data data-available">
                            <img
                              src="../../img/data-not-available.png"
                              alt="data not available"
                            />
                            <h3>{t(`View Details.No Item Found`)}</h3>
                            <p>
                              {t(`View Details.Sorry, we could not find any`)}
                              <br />
                              {t(`View Details.Item to show here`)}
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default ScreeningTest;
